import React, { useMemo, useState, useEffect, useContext } from 'react';
import { useNavigate, useLocation, useParams, Navigate } from "react-router-dom";
import axios from 'axios';
import Header from "../../components/dashboard/header";
import Sidebar from "../../components/dashboard/sidebar";
import { contentContext } from "../../context/contentContext";
import SessionPopup from "../SessionPopup"
import Calendar from 'react-calendar';
import Loader from "../../components/loader";
import 'react-calendar/dist/Calendar.css';
import Select from "react-select";
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import Tooltip from '@mui/material/Tooltip';
import { ToastContainer, toast } from 'react-toastify';

import { Troubleshoot } from '@mui/icons-material';
let { lambda, appname } = window.app

const bookedSlots = {
  '1AM': ['Premium', 'VIP'],
  '3PM': ['Premium', 'VIP'],
  '5PM': ['Free', 'VIP'],
  '8PM': ['Free'],
  '10PM': ['Premium']
};

// Custom Toolbar Component to Hide Today, Back, Next Buttons
const CustomToolbar = () => <div />;

// Custom Header Component to Hide Date Headers
const CustomHeader = () => <div style={{ display: 'none' }} />;

const SpotsManage = () => {
  let { id } = useParams();
  const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
  const [toastType, setToastType] = useState("")
  const { userData, setUserData, setActiveMenuId, isLoading, setIsLoading } = useContext(contentContext)
  const [selectedDate, setSelectedDate] = useState(null);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [showSessionPopupup, setShowSessionPopupup] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [image, setImg] = useState(process.env.REACT_APP_IMAGE_CLOUD_FRONT);
  const [showPopup, setShowPoup] = useState(false)
  const [showSpecialHours, setShowSpecialHours] = useState(false)
  const [dayName, setDayName] = useState('');
  const [showCalender, setShowcalender] = useState(false)
  const [plans, setPlans] = useState([]);
  const [isActive, setIsActive] = useState("regular")
  const [spotDay, setSpotDay] = useState('MONDAY')
  const [selectedDays, setSelectedDays] = useState(["MONDAY"]);
  const [editingPlans, setEditingPlans] = useState({});
  const [singleSplSpot, setSingleSplSpot] = useState([])
  const navigate = useNavigate();
  const [selectedSlots, setSelectedSlots] = useState([]); // Store added slots
  const daysOfWeek = ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY'];
  const [plansData, setPlansData] = useState([])
  const [spotsData, setSpotsData] = useState([])
  const [singleSplData, setSingleSplData] = useState({})
  const [SpecialSpotData, setSpecialSpotData] = useState("")
  const [singleSpot, setSingleSpot] = useState({})
  const [singleDayData, setSingleDayData] = useState([])
  const [formData, setFormData] = useState({
    // businessaddress: '',
    // name: '',
    // category: '',
    // phone: '',
    // logo: [],
    // storeImages: [],
    // idc: "USA(+1)",
    // maxVisitor: 0,
    // maxPartySize: 0,
    // codeExpiration: 0,
    // automatedExit: 0,
    // visitDuration: 0,
    // maxLocationCapacity: 0,
    // basicPlan: {},
    // premiumPlan: {},
    // vipPlan: {}


  });
  const [loaderEnable, setLoaderEnable] = useState(false);


  const days = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
  const hours = Array.from({ length: 24 * 4 }, (_, index) => {
    const totalMinutes = index * 15;
    const hour = Math.floor(totalMinutes / 60) % 12 || 12; // Convert 24-hour format to 12-hour
    const minute = (totalMinutes % 60).toString().padStart(2, "0");
    const period = totalMinutes < 720 ? "AM" : "PM";

    return `${hour}:${minute} ${period}`.trim();
  });

  const [selectedDay, setSelectedDay] = useState('MONDAY');
  const [selectedDayNew, setSelectedDayNew] = useState('MONDAY');
  const [timeSlots, setTimeSlots] = useState({
    starttime: '',
    endtime: ''
  });
  const [showModal, setShowModal] = useState(true);
  const [isOpen, setIsOpen] = useState(true);
  const [selectedOpenTime, setSelectedOpenTime] = useState('');
  const [selectedCloseTime, setSelectedCloseTime] = useState('');
  const [workingHours, setWorkingHours] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [commonLoader, setCommonLoader] = useState(false);
  const [editIndex, setEditIndex] = useState(null);

  // Premium & VIP hours states
  const [hourCategories, setHourCategories] = useState([
    { name: 'BASIC HOURS', hours: [] },
    { name: 'PREMIUM HOURS', hours: [] },
    { name: 'VIP HOURS', hours: [] }
  ]);


  const [maxVisitors, setMaxVisitors] = useState(0);
  const [pricePerSpot, setPricePerSpot] = useState(0);
  const [categoryEditMode, setCategoryEditMode] = useState(false);
  const [categoryEditIndex, setCategoryEditIndex] = useState(null);
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);


  // Update handleEditCategoryHours to save the original close time
  const [selectedStartTime, setSelectedStartTime] = useState('');
  const [selectedEndTime, setSelectedEndTime] = useState('');

  const [nextId, setNextId] = useState(1);
  const [categoryTypes, setCategoryTypes] = useState([
    // { name: 'BASIC HOURS', plan: 'Basic', price: 1 },
    // { name: 'PREMIUM HOURS', plan: 'Premium', price: 1000 },
    // { name: 'VIP HOURS', plan: 'VIP', price: 2000 }
  ]);

  // Category management
  // let categoryTypes = [
  //   { name: 'BASIC HOURS', plan: 'Basic', price: 1 },
  //   { name: 'PREMIUM HOURS', plan: 'Premium', price: 1000 },
  //   { name: 'VIP HOURS', plan: 'VIP', price: 2000 }
  // ];

  const [categoryHours, setCategoryHours] = useState([]);
  const [selectedCategoryStartTime, setSelectedCategoryStartTime] = useState('');
  const [selectedCategoryEndTime, setSelectedCategoryEndTime] = useState('');

  // Helper values
  const [endTimeKey, setEndTimeKey] = useState(0);
  const [categoryEndTimeKey, setCategoryEndTimeKey] = useState(0);
  const [originalCloseTime, setOriginalCloseTime] = useState(null);
  const [closeTimeKey, setCloseTimeKey] = useState(0);
  useEffect(() => {
    // Reset close time whenever open time changes
    setSelectedCloseTime('');
    // Increment the key to force re-render of the close time dropdown
    setCloseTimeKey(prevKey => prevKey + 1);
  }, [selectedOpenTime]);
  // Days of the week


  useEffect(() => {
    if (toastMessage && toastType && toast[toastType]) {
      toast[toastType](toastMessage, {
        position: "bottom-center",
        // autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });

      // Clear the message after showing to prevent re-triggering
      setToastMessage && setToastMessage("");
    }
  }, [toastMessage, toastType]);
  // Reset end time whenever start time changes for working hours
  useEffect(() => {
    setSelectedEndTime('');
    setEndTimeKey(prevKey => prevKey + 1);
  }, [selectedStartTime]);

  // Reset end time whenever start time changes for category hours
  useEffect(() => {
    setSelectedCategoryEndTime('');
    setCategoryEndTimeKey(prevKey => prevKey + 1);
  }, [selectedCategoryStartTime]);

  // Handle editing category hours
  useEffect(() => {
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];

      // Set form values
      setMaxVisitors(hourToEdit.maxvisitors);
      setPricePerSpot(hourToEdit.price);
      setSelectedCategoryStartTime(hourToEdit.starttime);

      // Set end time after start time to ensure dependencies resolve properly
      setTimeout(() => {
        setSelectedCategoryEndTime(hourToEdit.endtime);
      }, 50);
    }
  }, [categoryEditMode, categoryEditIndex]);


  // Parse time string to extract hour and minute
  const parseTimeString = (timeString) => {
    if (!timeString) return { hour: 0, minute: 0 };
    const [hourStr, minuteStr] = timeString.split(':');
    return {
      hour: parseInt(hourStr, 10),
      minute: parseInt(minuteStr, 10)
    };
  };

  // Get the next day of the week
  const getNextDay = (day) => {
    const index = daysOfWeek.indexOf(day);
    return index < daysOfWeek.length - 1 ? daysOfWeek[index + 1] : daysOfWeek[0];
  };

  // Check if a time is within a given range
  const isTimeWithinRange = (time, rangeStart, rangeEnd) => {
    if (time.hour > rangeStart.hour || (time.hour === rangeStart.hour && time.minute >= rangeStart.minute)) {
      if (time.hour < rangeEnd.hour || (time.hour === rangeEnd.hour && time.minute < rangeEnd.minute)) {
        return true;
      }
    }
    return false;
  };

  // Generate 24-hour time slots with 15-minute intervals
  const generateTimeOptions = (day, startHour = 0, startMinute = 0, hoursToGenerate = 24) => {
    const times = [];
    let currentHour = startHour;
    let currentMinute = startMinute;
    const dayAbbr = day?.substring(0, 3);

    for (let i = 0; i < hoursToGenerate * 4; i++) {
      const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

      times.push({
        value: timeValue,
        displayValue: formatTimeForDisplay(timeValue, day),
        hour: currentHour,
        minute: currentMinute,
        day: day
      });

      currentMinute += 15;
      if (currentMinute === 60) {
        currentMinute = 0;
        currentHour++;
      }
    }

    return times;
  };

  // Validate if a new time range would overlap with existing working hours
  const wouldTimeRangeOverlap = (startTime, endTime, excludeId = null) => {
    const start = parseTimeString(startTime);
    const end = parseTimeString(endTime);

    return workingHours.some(slot => {
      if (excludeId === slot.id) return false;

      const slotStart = parseTimeString(slot.starttime);
      const slotEnd = parseTimeString(slot.endtime);

      return (
        (start.hour < slotEnd.hour || (start.hour === slotEnd.hour && start.minute < slotEnd.minute)) &&
        (end.hour > slotStart.hour || (end.hour === slotStart.hour && end.minute > slotStart.minute))
      );
    });
  };

  // Get all start time options for the selected day
  const getStartTimeOptions = () => {
    const dayOptions = generateTimeOptions(selectedDay);

    // Filter out times that would overlap with any existing working hours
    return dayOptions.filter(time => {
      // If in edit mode, don't consider the time slot being edited
      // const relevantWorkingHours = editMode
      //   ? workingHours.filter(hour => hour.id !== editIndex)
      //   : workingHours;

      const relevantWorkingHours = editMode
        ? (workingHours || []).filter(hour => hour.id !== editIndex)
        : (workingHours || []);

      // Check for each working hour slot if the current time would create an overlap
      for (const slot of relevantWorkingHours) {
        const slotStartTime = parseTimeString(slot.starttime);
        const slotEndTime = parseTimeString(slot.endtime);

        // Check if this time is already within an existing slot
        if (isTimeWithinRange(time, slotStartTime, slotEndTime)) {
          return false;
        }
      }

      return true;
    });
  };



  // Handle editing working hours
  const handleEditWorkingHours = (id) => {
    const hourToEdit = workingHours.find(hour => hour.id === id);
    if (!hourToEdit) return;

    setSelectedStartTime(hourToEdit.starttime);
    setSelectedEndTime(hourToEdit.endtime);
    setEditMode(true);
    setEditIndex(id);
  };

  // Handle deleting working hours
  const handleDeleteWorkingHours = (id) => {
    // Remove the working hour.
    console.log("workingHours",workingHours)
    console.log("id",id)
    const updatedHours = workingHours.filter(hour => hour.id !== id);
    setWorkingHours(updatedHours);

    // Remove any category hours with this ID
    const updatedCategoryHours = categoryHours.filter(hour => hour.id !== id);
    setCategoryHours(updatedCategoryHours);

    // Reset if in edit mode
    if (editMode && editIndex === id) {
      setEditMode(false);
      setEditIndex(null);
      setSelectedStartTime('');
      setSelectedEndTime('');
    }
  };



  // Handle deleting category hours
  const handleDeleteCategoryHours = (index) => {
    const updatedCategoryHours = categoryHours.filter((_, i) => i !== index);
    setCategoryHours(updatedCategoryHours);

    // Reset if in edit mode
    if (categoryEditMode && categoryEditIndex === index) {
      setCategoryEditMode(false);
      setCategoryEditIndex(null);
      setSelectedCategoryStartTime('');
      setSelectedCategoryEndTime('');
      setMaxVisitors(0);
      setPricePerSpot(0);
    }
  };



  useEffect(() => {
 //   console.log("selectedDay:", selectedDay);
  }, [selectedDay]);

  useEffect(() => {
   // console.log("selectedStartTime:", selectedStartTime);
  }, [selectedStartTime]);

  useEffect(() => {
   // console.log("selectedEndTime:", selectedEndTime);
  }, [selectedEndTime]);

  useEffect(() => {
   // console.log("workingHours:", workingHours);
   const maxId = Math.max(0, ...workingHours.map(h => h.id || 0));
  setNextId(maxId + 1);
  }, [workingHours]);

  useEffect(() => {
   // console.log("editMode:", editMode);
  }, [editMode]);

  useEffect(() => {
    //console.log("editIndex:", editIndex);
  }, [editIndex]);

  useEffect(() => {
  //  console.log("nextId:", nextId);
  }, [nextId]);

  useEffect(() => {
   // console.log("categoryHours:", categoryHours);
  }, [categoryHours]);

  useEffect(() => {
   // console.log("selectedCategoryStartTime:", selectedCategoryStartTime);
  }, [selectedCategoryStartTime]);

  useEffect(() => {
   // console.log("selectedCategoryEndTime:", selectedCategoryEndTime);
  }, [selectedCategoryEndTime]);

  useEffect(() => {
   // console.log("maxVisitors:", maxVisitors);
  }, [maxVisitors]);

  useEffect(() => {
    //console.log("pricePerSpot:", pricePerSpot);
  }, [pricePerSpot]);

  useEffect(() => {
    //console.log("categoryEditMode:", categoryEditMode);
  }, [categoryEditMode]);

  useEffect(() => {
   // console.log("categoryEditIndex:", categoryEditIndex);
  }, [categoryEditIndex]);

  useEffect(() => {
   // console.log("activeCategoryIndex:", activeCategoryIndex);
  }, [activeCategoryIndex]);


  const formatTimeForDisplay = (timeString, day, isEndTime = false, startTimeDay = null) => {
    if (!timeString) return '';

    const [hourStr, minuteStr] = timeString.split(':');
    const hour = parseInt(hourStr, 10);
    const minute = parseInt(minuteStr, 10);

    const hour12 = hour % 12 === 0 ? 12 : hour % 12;
    const amPm = hour < 12 ? 'AM' : 'PM';
    const formattedHour = String(hour12).padStart(2, '0');
    const formattedMinute = String(minute).padStart(2, '0');

    // Determine which day to display for end times
    let displayDay = day;
    if (isEndTime && startTimeDay) {
      // If this is an end time and we have a start time to compare with
      const startDay = startTimeDay;
      const startHour = parseTimeString(startTimeDay.time).hour;

      // If end time is earlier in the day than start time, it's likely the next day
      if (hour < startHour || (hour === startHour && minute < parseTimeString(startTimeDay.time).minute)) {
        displayDay = getNextDay(startDay.day);
      }
    }

    const dayAbbr = displayDay?.substring(0, 3);
    return `${formattedHour}:${formattedMinute} ${amPm} (${dayAbbr})`;
  };

  useEffect(() => {
    if (editMode && editIndex !== null) {
      const hourToEdit = workingHours.find(hour => hour.id === editIndex);
      if (hourToEdit) {
        // First set the start time
        setSelectedStartTime(hourToEdit.starttime);

        // Then set the end time directly, bypassing the reset effect
        setSelectedEndTime(hourToEdit.endtime);
      }
    }
  }, [editMode, editIndex, workingHours]);


  useEffect(() => {
    // Only reset end time when start time changes and NOT in edit mode
    if (!editMode) {
      setSelectedEndTime('');
      setEndTimeKey(prevKey => prevKey + 1);
    }
  }, [selectedStartTime, editMode]);

  // 4. Modify the getEndTimeOptions function to properly handle next day times
  const getEndTimeOptions = () => {
    if (!selectedStartTime) return [];

    const selectedStart = parseTimeString(selectedStartTime);
    const dayOptions = generateTimeOptions(selectedDay);
    const nextDayOptions = generateTimeOptions(getNextDay(selectedDay));

    // Add day information to each option
    const dayOptionsWithDay = dayOptions.map(option => ({
      ...option,
      actualDay: selectedDay
    }));

    const nextDayOptionsWithDay = nextDayOptions.map(option => ({
      ...option,
      actualDay: getNextDay(selectedDay)
    }));

    // Combine current day and next day options
    const allOptions = [...dayOptionsWithDay, ...nextDayOptionsWithDay];

    // Find the index of the selected start time
    const selectedStartIndex = allOptions.findIndex(
      time => time.hour === selectedStart.hour && time.minute === selectedStart.minute && time.actualDay === selectedDay
    );

    if (selectedStartIndex === -1) return [];

    // Get all potential end times (times after the selected start time)
    const potentialEndTimes = allOptions.slice(selectedStartIndex + 1);

    // Filter out times that would overlap with existing working hours
    return potentialEndTimes.filter(endTime => {
      // If in edit mode, don't consider the time slot being edited
      const relevantWorkingHours = editMode
        ? workingHours.filter(hour => hour.id !== editIndex)
        : workingHours;

      // Check for overlap with each existing working hour slot
      for (const slot of relevantWorkingHours) {
        const slotStartTime = parseTimeString(slot.starttime);
        const slotEndTime = parseTimeString(slot.endtime);

        // Handle case where slot end time might be in next day (earlier hours)
        const slotIsOvernight = slotEndTime.hour < slotStartTime.hour ||
          (slotEndTime.hour === slotStartTime.hour && slotEndTime.minute < slotStartTime.minute);

        // Check if this potential end time would overlap with existing slots
        const isCurrentDayEnd = endTime.actualDay === selectedDay;
        const isNextDayEnd = endTime.actualDay === getNextDay(selectedDay);

        // Case 1: Selected start time is before slot's start time
        if (selectedStart.hour < slotStartTime.hour ||
          (selectedStart.hour === slotStartTime.hour && selectedStart.minute < slotStartTime.minute)) {

          // End time must be before or equal to the slot's start time
          if (isCurrentDayEnd && (endTime.hour > slotStartTime.hour ||
            (endTime.hour === slotStartTime.hour && endTime.minute > slotStartTime.minute))) {
            return false;
          }
        }

        // Case 2: Selected start time is within or after the slot
        else if (slotIsOvernight) {
          // For overnight slots, compare with care
          if (isCurrentDayEnd && (slotStartTime.hour <= endTime.hour)) {
            return false;
          }
        } else if (selectedStart.hour < slotEndTime.hour ||
          (selectedStart.hour === slotEndTime.hour && selectedStart.minute < slotEndTime.minute)) {
          // Start time is within the slot, which shouldn't be possible due to getStartTimeOptions filtering
          return false;
        }
      }

      return true;
    });
  };
  // console.log('category types', categoryTypes)
  // console.log('maxvisitors', maxVisitors)
  // console.log('pricePerSpot', pricePerSpot)
  // 5. Modify the handleAddWorkingHours function to store day information correctly
  const handleAddWorkingHours = () => {
    if (!selectedStartTime || !selectedEndTime) {
      setToastMessage("Please select both start and end times");
      setToastType("error");
      return;
    }
  
    if (wouldTimeRangeOverlap(selectedStartTime, selectedEndTime, editMode ? editIndex : null)) {
      alert("This time range would overlap with existing working hours. Please select a different range.");
      return;
    }
  
    const startTime = parseTimeString(selectedStartTime);
    const endTime = parseTimeString(selectedEndTime);
    const isOvernight = endTime.hour < startTime.hour ||
      (endTime.hour === startTime.hour && endTime.minute < startTime.minute);
  
    const hourId = editMode ? editIndex : nextId;
  
    const newWorkingHour = {
      id: hourId,
      starttime: selectedStartTime,
      endtime: selectedEndTime,
      day: selectedDay,
      endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
     // startendid: generateUniqueId() // optional, if you want a Mongo-style UID
    };
  
    let updatedWorkingHours;
  
    if (editMode) {
      updatedWorkingHours = workingHours.map(hour =>
        hour.id === editIndex ? newWorkingHour : hour
      );
  
      const updatedCategoryHours = categoryHours.map(hour => {
        if (hour.id === editIndex) {
          return {
            ...hour,
            starttime: selectedStartTime,
            endtime: selectedEndTime,
            day: selectedDay,
            endDay: newWorkingHour.endDay
          };
        }
        return hour;
      });
  
      setCategoryHours(updatedCategoryHours);
      setEditMode(false);
      setEditIndex(null);
    } else {
      updatedWorkingHours = [...workingHours, newWorkingHour];
  
      // Add category hours per plan
      const newCategoryHours = categoryTypes.map(category => ({
        plan: category.plan,
        price: category.price,
        maxvisitors: category.maxvisitors,
        starttime: selectedStartTime,
        endtime: selectedEndTime,
        day: selectedDay,
        endDay: newWorkingHour.endDay,
        id: hourId,
        workingHourId: hourId // optional but recommended
      }));
  
      setCategoryHours(prev => [...prev, ...newCategoryHours]);
      setNextId(prev => prev + 1); // Increment only after adding
    }
  
    setWorkingHours(updatedWorkingHours);
    setSelectedStartTime('');
    setSelectedEndTime('');
  };
  
  // const generateUniqueId = () => {
  //   return Math.random().toString(16).slice(2) + Date.now().toString(16);
  // };

  useEffect(() => {
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];

      // Set all form values at once
      setMaxVisitors(hourToEdit.maxvisitors);
      setPricePerSpot(hourToEdit.price);
      setSelectedCategoryStartTime(hourToEdit.starttime);
      setSelectedCategoryEndTime(hourToEdit.endtime);
    }
  }, [categoryEditMode, categoryEditIndex]);

  // 3. Change the useEffect that resets category end time to respect edit mode
  // Replace the current useEffect with this:
  useEffect(() => {
    // Only reset end time when start time changes and NOT in category edit mode
    if (!categoryEditMode) {
      setSelectedCategoryEndTime('');
      setCategoryEndTimeKey(prevKey => prevKey + 1);
    }
  }, [selectedCategoryStartTime, categoryEditMode]);

  // 4. Update the getCategoryEndTimeOptions function to handle overnight times
  const getCategoryEndTimeOptions = () => {
    if (!selectedCategoryStartTime) return [];

    // Find the working hour that contains this start time
    const workingHour = workingHours.find(hour => {
      const startTime = parseTimeString(hour.starttime);
      const endTime = parseTimeString(hour.endtime);
      const selectedTime = parseTimeString(selectedCategoryStartTime);

      return isTimeWithinRange(selectedTime, startTime, endTime) ||
        (startTime.hour === selectedTime.hour && startTime.minute === selectedTime.minute);
    });

    if (!workingHour) return [];

    // Generate all time slots from the selected start time to the end of the working hour
    const startTime = parseTimeString(selectedCategoryStartTime);
    const endTime = parseTimeString(workingHour.endtime);

    // Determine if the working hour extends to the next day
    const isOvernight = endTime.hour < parseTimeString(workingHour.starttime).hour ||
      (endTime.hour === parseTimeString(workingHour.starttime).hour &&
        endTime.minute < parseTimeString(workingHour.starttime).minute);

    const endTimeOptions = [];
    let currentHour = startTime.hour;
    let currentMinute = startTime.minute;

    // Add 15 minutes to start with the next slot
    currentMinute += 15;
    if (currentMinute === 60) {
      currentMinute = 0;
      currentHour++;
    }

    const maxHour = isOvernight ? 23 : endTime.hour;
    const maxMinute = isOvernight ? 45 : endTime.minute;

    // Generate all slots until the end of the working hour for current day
    while (
      currentHour < maxHour ||
      (currentHour === maxHour && currentMinute <= maxMinute)
    ) {
      const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

      endTimeOptions.push({
        value: timeValue,
        displayValue: formatTimeForDisplay(timeValue, selectedDay),
        hour: currentHour,
        minute: currentMinute,
        day: selectedDay,
        actualDay: selectedDay
      });

      currentMinute += 15;
      if (currentMinute === 60) {
        currentMinute = 0;
        currentHour++;
      }
    }

    // If overnight, add the next day options (00:00 to endTime)
    if (isOvernight) {
      currentHour = 0;
      currentMinute = 0;

      while (
        currentHour < endTime.hour ||
        (currentHour === endTime.hour && currentMinute <= endTime.minute)
      ) {
        const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

        endTimeOptions.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, getNextDay(selectedDay)),
          hour: currentHour,
          minute: currentMinute,
          day: getNextDay(selectedDay),
          actualDay: getNextDay(selectedDay)
        });

        currentMinute += 15;
        if (currentMinute === 60) {
          currentMinute = 0;
          currentHour++;
        }
      }
    }

    // If in edit mode, make sure the current end time is included
    if (categoryEditMode && categoryEditIndex !== null) {
      const editingHour = categoryHours[categoryEditIndex];
      const endTimeExists = endTimeOptions.some(opt => opt.value === editingHour.endtime);

      if (!endTimeExists && editingHour.starttime === selectedCategoryStartTime) {
        const { hour, minute } = parseTimeString(editingHour.endtime);
        const timeValue = editingHour.endtime;

        // Determine the day for this end time
        const isEditedHourOvernight = hour < startTime.hour ||
          (hour === startTime.hour && minute < startTime.minute);
        const endTimeDay = isEditedHourOvernight ? getNextDay(selectedDay) : selectedDay;

        endTimeOptions.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, endTimeDay),
          hour: hour,
          minute: minute,
          day: endTimeDay,
          actualDay: endTimeDay
        });

        // Sort by time
        endTimeOptions.sort((a, b) => {
          if (a.actualDay !== b.actualDay) {
            // Different days - next day comes after current day
            return a.actualDay === selectedDay ? -1 : 1;
          }
          if (a.hour !== b.hour) return a.hour - b.hour;
          return a.minute - b.minute;
        });
      }
    }

    return endTimeOptions;
  };

  // const isMaxVisitorsValid = () => {
  //   console.log("1111111111111111111")
  //   let total = categoryHours.reduce((sum, hour, index) => {
  //     if (categoryEditMode && index === categoryEditIndex) {
  //       return sum + (Number(maxVisitors) || 0);
  //     }
  //     return sum + (Number(hour.maxvisitors) || 0);
  //   }, 0);
  
  //   return total <= maxVisitors;
  // };

  // 5. Update the handleAddCategoryHours function to handle overnight times
  // const handleAddCategoryHours = () => {
  //   if (!selectedCategoryStartTime || !selectedCategoryEndTime) {

  //     setToastMessage("Please select both start and end times");
  //     setToastType("error");
  //     return;
  //   }

  //   const categoryPlan = categoryTypes[activeCategoryIndex].plan;

  //   // Determine if end time is on the next day
  //   const startTime = parseTimeString(selectedCategoryStartTime);
  //   const endTime = parseTimeString(selectedCategoryEndTime);
  //   const isOvernight = endTime.hour < startTime.hour ||
  //     (endTime.hour === startTime.hour && endTime.minute < startTime.minute);

  //   // Find the corresponding working hour for this time range
  //   const workingHourId = findWorkingHourIdForTimeRange(selectedCategoryStartTime, selectedCategoryEndTime);

  //   const newCategoryHour = {
  //     plan: categoryPlan,
  //     price: pricePerSpot || categoryTypes[activeCategoryIndex].price,
  //     maxvisitors: maxVisitors,
  //     starttime: selectedCategoryStartTime,
  //     endtime: selectedCategoryEndTime,
  //     day: selectedDay,
  //     endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
  //     id: workingHourId
  //   };

  //   if (categoryEditMode) {
  //     // Update existing category hour
  //     const updatedCategoryHours = categoryHours.map((hour, index) =>
  //       index === categoryEditIndex ? newCategoryHour : hour
  //     );

  //     setCategoryHours(updatedCategoryHours);
  //     setCategoryEditMode(false);
  //     setCategoryEditIndex(null);
  //   } else {
  //     // Add new category hour
  //     setCategoryHours([...categoryHours, newCategoryHour]);
  //   }

  //   // Reset selections
  //   setSelectedCategoryStartTime('');
  //   setSelectedCategoryEndTime('');
  //   setMaxVisitors('');
  //   setPricePerSpot('');
  // };

  const handleAddCategoryHours = () => {
    if (!selectedCategoryStartTime || !selectedCategoryEndTime) {
      setToastMessage("Please select both start and end times");
      setToastType("error");
      return;
    }
  
    const categoryPlan = categoryTypes[activeCategoryIndex].plan;
    const startTime = parseTimeString(selectedCategoryStartTime);
    const endTime = parseTimeString(selectedCategoryEndTime);
    const isOvernight = endTime.hour < startTime.hour || 
      (endTime.hour === startTime.hour && endTime.minute < startTime.minute);
    const workingHourId = findWorkingHourIdForTimeRange(selectedCategoryStartTime, selectedCategoryEndTime);
  
    const newCategoryHour = {
      plan: categoryPlan,
      price: pricePerSpot || categoryTypes[activeCategoryIndex].price,
      maxvisitors: Number(maxVisitors),
      starttime: selectedCategoryStartTime,
      endtime: selectedCategoryEndTime,
      day: selectedDay,
      endDay: isOvernight ? getNextDay(selectedDay) : selectedDay,
      id: workingHourId
    };
  
    let updatedHours = categoryHours.slice();
  
    if (categoryEditMode) {
      updatedHours = updatedHours.map((hour, index) =>
        index === categoryEditIndex ? newCategoryHour : hour
      );
    } else {
      updatedHours.push(newCategoryHour);
    }
  
    const totalVisitors = updatedHours.reduce((sum, hour) => sum + (Number(hour.maxvisitors) || 0), 0);
  
    const maxvisitor = formData?.maxVisitor;  // or get this from your state/config
  
    if (totalVisitors > maxvisitor) {
      setToastMessage(`Total visitors per spot exceed limit of ${maxvisitor}. Current total: ${totalVisitors}`);
      setToastType("error");
      return;
    }
  
    setCategoryHours(updatedHours);
    setCategoryEditMode(false);
    setCategoryEditIndex(null);
  
    setSelectedCategoryStartTime('');
    setSelectedCategoryEndTime('');
    setMaxVisitors('');
    setPricePerSpot('');
  };
  
  


  // 7. Update the findWorkingHourIdForTimeRange function to better handle time ranges
  const findWorkingHourIdForTimeRange = (startTime, endTime) => {
    const start = parseTimeString(startTime);
    const end = parseTimeString(endTime);

    // Check if this is an overnight timespan
    const isOvernight = end.hour < start.hour ||
      (end.hour === start.hour && end.minute < start.minute);

    const hour = workingHours.find(h => {
      const hStart = parseTimeString(h.starttime);
      const hEnd = parseTimeString(h.endtime);

      // Check if the working hour is also overnight
      const hIsOvernight = hEnd.hour < hStart.hour ||
        (hEnd.hour === hStart.hour && hEnd.minute < hStart.minute);

      // For simple same-day comparisons
      if (!isOvernight && !hIsOvernight) {
        return hStart.hour <= start.hour && hEnd.hour >= end.hour &&
          start.hour <= end.hour;
      }

      // For overnight comparisons
      if (isOvernight && hIsOvernight) {
        // Both ranges are overnight, check containment
        return hStart.hour <= start.hour &&
          ((hEnd.hour > end.hour) || (hEnd.hour === end.hour && hEnd.minute >= end.minute));
      }

      // Mixed cases (one overnight, one not) - handle with specific logic
      return h.starttime <= startTime &&
        ((hIsOvernight && end.hour <= 23) || (!hIsOvernight && h.endtime >= endTime));
    });

    return hour ? hour.id : null;
  };

 // console.log('Updated Selected Days:3333333333333333333333333', selectedDays)


  // Modify the getCategoryStartTimeOptions function to properly handle overnight editing
  const getCategoryStartTimeOptions = () => {
    // Special case for edit mode - if we're editing, we need to ensure the current start time is available
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];
      const categoryPlan = categoryTypes[activeCategoryIndex].plan;

      // If we're editing a record in the currently active category
      if (hourToEdit?.plan === categoryPlan) {
        // Find the corresponding working hour
        const correspondingWorkingHour = workingHours.find(hour => hour.id === hourToEdit.id);

        if (correspondingWorkingHour) {
          // Generate all available time slots from the working hour
          const startTime = parseTimeString(correspondingWorkingHour.starttime);
          const endTime = parseTimeString(correspondingWorkingHour.endtime);

          const availableSlots = [];
          let currentHour = startTime.hour;
          let currentMinute = startTime.minute;

          // Include the hour being edited regardless of conflicts
          const editingStartTime = hourToEdit.starttime;

          // Generate all time slots from working hour
          while (
            currentHour < endTime.hour ||
            (currentHour === endTime.hour && currentMinute < endTime.minute) ||
            // Handle overnight scenario
            (endTime.hour < startTime.hour)
          ) {
            const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

            // Only add slots that don't conflict with other category hours of the same plan
            // or if it's the slot we're currently editing
            const isCurrentlyEditedTime = timeValue === editingStartTime;

            const isTimeUsed = categoryHours.some((hour, index) => {
              // Skip the hour being edited
              if (index === categoryEditIndex) {
                return false;
              }

              // Only check hours with the same plan
              if (hour.plan !== categoryPlan) {
                return false;
              }

              // Check if this time slot is already used
              const hourStart = parseTimeString(hour.starttime);
              const hourEnd = parseTimeString(hour.endtime);

              // Handle overnight scenarios
              const isHourOvernight = hourEnd.hour < hourStart.hour ||
                (hourEnd.hour === hourStart.hour && hourEnd.minute < hourStart.minute);

              if (hour.starttime === timeValue) {
                return true;
              }

              if (isHourOvernight) {
                // For overnight hours, check if time is between start and midnight or between midnight and end
                if (
                  (currentHour >= hourStart.hour && currentHour <= 23) ||
                  (currentHour >= 0 && currentHour < hourEnd.hour) ||
                  (currentHour === hourEnd.hour && currentMinute < hourEnd.minute)
                ) {
                  return true;
                }
              } else {
                // For same-day hours, simple range check
                if (
                  (currentHour > hourStart.hour || (currentHour === hourStart.hour && currentMinute >= hourStart.minute)) &&
                  (currentHour < hourEnd.hour || (currentHour === hourEnd.hour && currentMinute < hourEnd.minute))
                ) {
                  return true;
                }
              }

              return false;
            });

            if (isCurrentlyEditedTime || !isTimeUsed) {
              availableSlots.push({
                value: timeValue,
                displayValue: formatTimeForDisplay(timeValue, selectedDay),
                hour: currentHour,
                minute: currentMinute,
                day: selectedDay
              });
            }

            currentMinute += 15;
            if (currentMinute === 60) {
              currentMinute = 0;
              currentHour++;
              if (currentHour === 24) currentHour = 0; // Handle midnight transition
            }

            // Break if we've gone full circle for overnight hours
            if (endTime.hour < startTime.hour && currentHour === startTime.hour && currentMinute === startTime.minute) {
              break;
            }
          }

          // Special case: ensure the editing start time is included
          const editingStartExists = availableSlots.some(slot => slot.value === editingStartTime);

          if (!editingStartExists) {
            const { hour, minute } = parseTimeString(editingStartTime);
            availableSlots.push({
              value: editingStartTime,
              displayValue: formatTimeForDisplay(editingStartTime, selectedDay),
              hour: hour,
              minute: minute,
              day: selectedDay
            });
          }

          // Sort by time
          availableSlots.sort((a, b) => {
            if (a.hour !== b.hour) return a.hour - b.hour;
            return a.minute - b.minute;
          });

          return availableSlots;
        }
      }
    }

    // Regular (non-edit) logic for getting available category start times
    // Get all time slots from working hours
    const availableSlots = [];

    workingHours?.forEach(slot => {
      const startTime = parseTimeString(slot.starttime);
      const endTime = parseTimeString(slot.endtime);
      let currentHour = startTime.hour;
      let currentMinute = startTime.minute;

      // Generate all 15-minute slots between start and end times
      while (
        currentHour < endTime.hour ||
        (currentHour === endTime.hour && currentMinute < endTime.minute) ||
        // Handle overnight scenario
        (endTime.hour < startTime.hour && (currentHour <= 23 || currentHour < endTime.hour))
      ) {
        const timeValue = `${String(currentHour).padStart(2, '0')}:${String(currentMinute).padStart(2, '0')}`;

        availableSlots.push({
          value: timeValue,
          displayValue: formatTimeForDisplay(timeValue, selectedDay),
          hour: currentHour,
          minute: currentMinute,
          day: selectedDay
        });

        currentMinute += 15;
        if (currentMinute === 60) {
          currentMinute = 0;
          currentHour++;
          if (currentHour === 24) currentHour = 0; // Handle midnight transition
        }

        // Break loop if we've gone full circle for overnight hours
        if (endTime.hour < startTime.hour && currentHour === startTime.hour && currentMinute === startTime.minute) {
          break;
        }
      }
    });

    // Filter out times that are already used in this category
    return availableSlots.filter(timeSlot => {
      // Filter based on the active category
      const categoryPlan = categoryTypes[activeCategoryIndex].plan;

      // Check if this time is already used in this category
      const isTimeUsed = categoryHours.some((hour, index) => {
        // Skip the hour being edited
        if (categoryEditMode && index === categoryEditIndex) {
          return false;
        }

        // Only check hours with the same plan
        if (hour.plan !== categoryPlan) {
          return false;
        }

        // Check if this time slot is the start time of another hour
        if (hour.starttime === timeSlot.value) {
          return true;
        }

        // Check if this time slot falls within another hour's range
        const hourStart = parseTimeString(hour.starttime);
        const hourEnd = parseTimeString(hour.endtime);

        // Handle overnight ranges
        const isOvernight = hourEnd.hour < hourStart.hour ||
          (hourEnd.hour === hourStart.hour && hourEnd.minute < hourStart.minute);

        if (isOvernight) {
          // For overnight ranges, check if the time is between start and midnight
          // or between midnight and end time
          return (timeSlot.hour >= hourStart.hour && timeSlot.hour <= 23) ||
            (timeSlot.hour >= 0 && timeSlot.hour < hourEnd.hour) ||
            (timeSlot.hour === hourEnd.hour && timeSlot.minute < hourEnd.minute);
        } else {
          // For same-day ranges, simple check
          return isTimeWithinRange(timeSlot, hourStart, hourEnd);
        }
      });

      return !isTimeUsed;
    });
  };


  // Modify handleEditCategoryHours to properly set up for editing overnight records
  const handleEditCategoryHours = (index) => {
    const hourToEdit = categoryHours[index];

    // First, set the active category
    setActiveCategoryIndex(categoryTypes.findIndex(cat => cat.plan === hourToEdit.plan));

    // Set editing mode
    setCategoryEditMode(true);
    setCategoryEditIndex(index);

    // Set form values in one go to avoid race conditions
    setMaxVisitors(hourToEdit.maxvisitors);
    setPricePerSpot(hourToEdit.price);

    // Need to set these in the correct order with a small delay to ensure the dropdown populates correctly
    setSelectedCategoryStartTime(hourToEdit.starttime);

    // Using setTimeout to ensure the start time is processed before setting end time
    setTimeout(() => {
      setSelectedCategoryEndTime(hourToEdit.endtime);
    }, 100);
  };

  // Update the useEffect that handles category editing to properly initialize form values
  useEffect(() => {
    if (categoryEditMode && categoryEditIndex !== null) {
      const hourToEdit = categoryHours[categoryEditIndex];

      // Set all form values
      setMaxVisitors(hourToEdit.maxvisitors);
      setPricePerSpot(hourToEdit.price);

      // Make sure we're setting values in correct order with delays to allow dependencies to update
      setSelectedCategoryStartTime(hourToEdit.starttime);

      // Need a delay before setting end time so that the dropdown can populate based on start time
      setTimeout(() => {
        setSelectedCategoryEndTime(hourToEdit.endtime);
      }, 100);
    }
  }, [categoryEditMode, categoryEditIndex]);

  // Modify the useEffect that resets the end time when the start time changes
  // to account for edit mode properly
  useEffect(() => {
    // Only reset end time when not in edit mode or when the user manually changes the start time
    if (categoryEditMode) {
      // In edit mode, don't reset end time automatically
      // This prevents the selected end time from being cleared during edit initialization
      return;
    }

    // For non-edit mode or manual changes, reset the end time
    setSelectedCategoryEndTime('');
    setCategoryEndTimeKey(prevKey => prevKey + 1);
  }, [selectedCategoryStartTime]);







  useEffect(() => {
    if (singleSpot !== null) {
      // console.log("State updated:", singleSpot);
    }
  }, [singleSpot]);



  const handleOpenTimeChange = (e) => {
    setTimeSlots({
      ...timeSlots,
      starttime: e.target.value,

    });

  };
  useEffect(() => {

    setActiveMenuId(200002)

  }, []);


  // const disablePastDates = ({ date }) => {
  //   const today = new Date();
  //   // Remove time portion for accurate comparison
  //   today.setHours(0, 0, 0, 0);
  //   return date < today;
  // };


  const disablePastDates = ({ date }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    // If singleSplHour and its date exist
    if (singleSplData?.spotspecialfromdate) {
      const specialDate = new Date(singleSplData.spotspecialfromdate);
      specialDate.setHours(0, 0, 0, 0);
      date.setHours(0, 0, 0, 0);

      // Enable only the date that matches the special date
      return date.getTime() !== specialDate.getTime();
    }

    // Default behavior: disable past dates
    return date < today;
  };


  // Disable past dates based on dataArray length condition
  // const disablePastDates = ({ date }) => {
  //   const today = new Date();
  //   // Remove time portion for accurate comparison
  //   today.setHours(0, 0, 0, 0);

  //   // Disable past dates only if the dataArray length is greater than 0
  //   if (workingHours.length > 0) {
  //     return date < today; // Disable past dates if condition is true
  //   }
  //   return false; // If the condition is false, don't disable any dates
  // };
  const handleDateChange = (date) => {
    // setSelectedDate(date);


    // Format to MM-DD-YYYY
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    const yyyy = date.getFullYear();

    const formatted = `${mm}-${dd}-${yyyy}`;
    setSelectedDate(formatted);
    // console.log('Selected date:', formatted);
    let day = date.toLocaleDateString('en-US', { weekday: 'long' });
    // console.log('dayyyyyyyyyyyyyyyyyy', day)

    const formattedDay = day.trim().toUpperCase();
    setSelectedDay(formattedDay)
    setDayName(formattedDay);
    // console.log("dayNameeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", formattedDay)
    // You can also format or store it in a global state here
  };
  // console.log('selected date', selectedDate)
  const userActivity = () => {
    let path = window.location.pathname.split("/");
    const pageName = path[path.length - 1];
    var presentTime = moment();
    let payload;

    payload = {
      "clientid": localStorage.getItem("clientid"),
      "pagename": pageName,
      "pageurl": window.location.href,
      "starttime": presentTime,
      "useragent": JSON.parse(localStorage.getItem("loc"))

    };


    const previousId = localStorage.getItem("previousid");
    const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


    axios({
      method: 'POST',
      url: urlLink,
      data: payload
    })
      .then(function (response) {
        if (response?.data?.statusCode === 200) {
          localStorage.setItem("previousid", response?.data?.result)
        }
      });
  }
  // console.log('activeCategoryIndex', activeCategoryIndex)

  const isDisabled = (time) => {
    if (!selectedSlots || selectedSlots.length === 0) return false; // No restrictions if no slots are selected

    const currentIndex = hours.indexOf(time);
    if (currentIndex === -1) return false; // If time is not found, return false

    const editStartIndex = hours.indexOf(timeSlots?.starttime);

    const cleanEndTime = timeSlots?.endtime
      ? timeSlots.endtime.replace(/\s*\(\w+\)\s*/, '').trim()
      : '';


    let editEndIndex = hours.indexOf(cleanEndTime);

    const spansNextDay = editEndIndex < editStartIndex;
    if (spansNextDay) {
      editEndIndex += hours.length; // Extend end index to include next day's hours
    }

    if (editStartIndex !== -1 && editEndIndex !== -1) {

      if (currentIndex >= editStartIndex && currentIndex <= editEndIndex) {

        return false; // Enable times within the editing range
      }
    }

    // Extract all selected start and end indexes, handling multi-day spans
    const selectedRanges = selectedSlots.map(slot => {

      const cleanEndTime = slot.endtime.replace(/\s*\(\w+\)\s*/, '').trim(); // Remove (Monday) etc.

      const startIdx = hours.indexOf(slot.starttime);
      let endIdx = hours.indexOf(cleanEndTime);


      if (startIdx === -1 || endIdx === -1) return null; // Skip invalid slots

      // Check if end time is before start time (spans to the next day)
      const spansNextDay = endIdx <= startIdx;

      if (spansNextDay) {
        endIdx += hours.length; // Adjust for next-day wrap-around
      }

      return { start: startIdx, end: endIdx, spansNextDay };
    }).filter(slot => slot !== null);



    // Check if the selected time falls within any existing slot range
    return selectedRanges.some(({ start, end, spansNextDay }) =>
      (currentIndex >= start && currentIndex <= end) ||  // Normal case (same day)
      // (spansNextDay && (currentIndex + hours.length >= start && currentIndex + hours.length <= end)) || // Next day wrap-around case
      (spansNextDay && currentIndex >= start) // Ensure end of Monday is also disabled
    );
  };



  const getValidPlanHours = (planName) => {
    const validSlots = [];

    // Retrieve the plan from editingPlans if we are editing
    const editingPlan = editingPlans[planName];
    const isEditingThisPlan = editingPlan !== undefined;

    // Pre-calculate start/end indices if we are editing
    const editingStart = editingPlan?.starttime?.replace(/\s*\(\w+\)\s*/, '').trim();
    const editingEnd = editingPlan?.endtime?.replace(/\s*\(\w+\)\s*/, '').trim();
    const editingStartIdx = hours.indexOf(editingStart);
    const editingEndIdx = hours.indexOf(editingEnd);

    plans.forEach(plan => {
      if (!plan.starttime || !plan.endtime) return;

      const endLabelMatch = plan.endtime.match(/\((\w+)\)/);
      const startDay = selectedDay;
      const endDay = endLabelMatch ? endLabelMatch[1] : '';

      const rawStart = plan.starttime.replace(/\s*\(\w+\)\s*/, '').trim();
      const rawEnd = plan.endtime.replace(/\s*\(\w+\)\s*/, '').trim();

      const startIdx = hours.indexOf(rawStart);
      const endIdx = hours.indexOf(rawEnd);
      if (startIdx === -1 || endIdx === -1) return;

      // Decide if a given hour index i should be enabled
      const shouldEnable = (i) => {
        if (!isEditingThisPlan) return false; // Only if editing
        if (editingStartIdx === -1 || editingEndIdx === -1) return false; // If editing plan times are invalid
        if (editingStartIdx <= editingEndIdx) {
          // same-day range
          return i >= editingStartIdx && i <= editingEndIdx;
        } else {
          // cross-day range
          return i >= editingStartIdx || i <= editingEndIdx;
        }
      };

      // Generate the slots for this plan
      if (endIdx <= startIdx) {
        // Cross-day plan
        for (let i = startIdx; i < hours.length; i++) {
          validSlots.push({
            label: `${hours[i]} (${startDay})`,
            value: hours[i],
            index: i,
            disabled: !shouldEnable(i),
          });
        }
        for (let i = 0; i <= endIdx; i++) {
          validSlots.push({
            label: `${hours[i]} (${endDay})`,
            value: hours[i],
            index: hours.length + i,
            disabled: !shouldEnable(i),
          });
        }
      } else {
        // Same-day plan
        for (let i = startIdx; i <= endIdx; i++) {
          validSlots.push({
            label: `${hours[i]} (${startDay})`,
            value: hours[i],
            index: i,
            disabled: !shouldEnable(i),
          });
        }
      }
    });

    // Sort by index to maintain chronological order
    validSlots.sort((a, b) => a.index - b.index);

    // Remove duplicates (using label-value as the key)
    const uniqueSlotsMap = new Map();
    for (const slot of validSlots) {
      const key = `${slot.label}-${slot.value}`;
      if (!uniqueSlotsMap.has(key)) {
        uniqueSlotsMap.set(key, slot);
      }
    }

    return Array.from(uniqueSlotsMap.values());
  };

  const getClosingPlanHours = (planName) => {
    const validSlots = [];
    const editingPlan = editingPlans[planName];

    if (!editingPlan) return [];

    const formattedDay = selectedDay

    // Extract only time part from "9:15 AM (Monday)"
    const rawStartTime = editingPlan?.starttime?.split('(')[0]?.trim();
    const rawEndTime = editingPlan?.endtime?.split('(')[0]?.trim();

    const startIdx = hours.indexOf(rawStartTime);
    const endIdx = hours.indexOf(rawEndTime);

    if (startIdx === -1 || endIdx === -1 || startIdx >= endIdx) return [];

    for (let i = startIdx + 1; i <= endIdx; i++) {
      validSlots.push({
        label: `${hours[i]} (${formattedDay})`,
        value: hours[i],
        index: i,
      });
    }

    return validSlots;
  };






  const handleCloseTimeChange = (e) => {


    setTimeSlots(prevState => ({
      ...prevState,
      endtime: e.target.value, // Store the label including the day
    }));

  };



  // Step 1: Generate hour labels
  const hoursLabel = Array.from({ length: 24 }, (_, i) => {
    const hour = i % 12 || 12;
    const suffix = i < 12 ? "AM" : "PM";
    const formattedHour = `${hour < 10 ? "0" + hour : hour}${suffix}`;
    // console.log(`Step 1 - Hour Label for ${i}:`, formattedHour);
    return formattedHour;
  });
  // console.log('Step 1 - All Hour Labels:', hoursLabel);

  // Step 2: Determine source of slots based on isActive state
  const slotsSource = isActive === "regular"
    ? singleSpot?.[0]?.daySpotDetails?.[0]?.spots
    : singleSplSpot?.daySpotDetails?.[0]?.spots;

  // console.log('Step 2 - Slot Source:', slotsSource);

  // Step 3: Group the slots by hour + period (e.g., "09AM")
  const groupedSlots = Array.isArray(slotsSource)
    ? slotsSource.reduce((acc, slot, index) => {
      // console.log(`Step 3 - Processing Slot ${index}:`, slot);

      const [time, period] = slot.spotstart.split(" "); // e.g., "09:00 AM"
      const hour = time.split(":")[0]; // "09"
      const hourKey = hour + period;   // e.g., "09AM"

      // console.log(`Step 3 - Extracted hourKey:`, hourKey);

      if (!acc[hourKey]) {
        acc[hourKey] = { hourLabel: period, slots: [] };
        // console.log(`Step 3 - Creating new group for hourKey ${hourKey}`);
      }

      acc[hourKey].slots.push(slot);
      // console.log(`Step 3 - Added slot to hourKey ${hourKey}:`, acc[hourKey].slots);
      return acc;
    }, {})
    : {}; // fallback to empty object if no valid array

  // console.log('Step 4 - Final Grouped Slots:', groupedSlots);


  // Step 1: Generate hour labels (keeping this the same)
  // const hoursLabel = Array.from({ length: 24 }, (_, i) => {
  //   const hour = i % 12 || 12;
  //   const suffix = i < 12 ? "AM" : "PM";
  //   const formattedHour = `${hour < 10 ? "0" + hour : hour}${suffix}`;
  //   return formattedHour;
  // });

  // Step 2: Determine source of slots based on isActive state (keeping this the same)
  // const slotsSource = isActive === "regular"
  //   ? singleSpot?.[0]?.daySpotDetails?.[0]?.spots
  //   : singleSplSpot?.daySpotDetails?.[0]?.spots;

  // Step 3: Extract unique days from the slots
  const uniqueDays = Array.isArray(slotsSource)
    ? [...new Set(slotsSource.map(slot => slot.day))]
    : [];

  // Step 4: Group the slots first by day and then by hour
  const slotsByDay = Array.isArray(slotsSource)
    ? slotsSource.reduce((acc, slot) => {
      const day = slot.day;
      const [time, period] = slot.spotstart.split(" "); // e.g., "09:00 AM"
      const hour = time.split(":")[0]; // "09"
      const hourKey = hour + period; // e.g., "09AM"

      // Initialize day if it doesn't exist
      if (!acc[day]) {
        acc[day] = {};
      }

      // Initialize hour in that day if it doesn't exist
      if (!acc[day][hourKey]) {
        acc[day][hourKey] = { hourLabel: period, slots: [] };
      }

      // Add slot to the appropriate day and hour
      acc[day][hourKey].slots.push(slot);
      return acc;
    }, {})
    : {};

  // Render the calendar table for each day
  const renderCalendarForDay = (day) => {
    const daySlots = slotsByDay[day] || {};

    return (
      <table className="table calander-grid mt-4" id={`calendar-table-${day}`} key={`table-${day}`}>
        <thead>
          <tr>
            <td className="timming-row day-show" id="week-day-show">W3</td>
            <td colSpan="4" className="text-center day-show" id={`day-show-${day}`}>{day}</td>
          </tr>
          <tr>
            <td className="timming-row time-display" id="time-display">all-day</td>
            <td className="timming-slot-section"></td>
            <td className="timming-slot-section"></td>
            <td className="timming-slot-section"></td>
            <td className="timming-slot-section"></td>
          </tr>
        </thead>
        <tbody>
          {hoursLabel.map((hourKey) => {
            const hourData = (daySlots[hourKey]) || { slots: [] };
            return (
              <tr key={`${day}-${hourKey}`}>
                <td className="time-display">{hourKey}</td>
                {hourData.slots.map((slot) => (
                  <td key={slot.spotid} id={`slot-${slot.spotid}`}>
                    <button className="timming_slot" id={`slot-btn-${slot.spotid}`}>
                      <span>{slot.spotstart}</span>
                      <span>
                        {slot.plans.includes("Basic") && (
                          <img src={`${image}${appname}/images/web/Free-Badge.svg`} alt="Free Badge" id="free-badge" />
                        )}
                        {slot.plans.includes("Premium") && (
                          <img src={`${image}${appname}/images/web/Premium-Badge.svg`} alt="Premium Badge" id="premium-badge" />
                        )}
                        {slot.plans.includes("VIP") && (
                          <img src={`${image}${appname}/images/web/VIP-Badge.svg`} alt="VIP Badge" id="vip-badge" />
                        )}
                      </span>
                    </button>
                  </td>
                ))}
                {hourData.slots.length < 4 &&
                  Array(4 - hourData.slots.length)
                    .fill()
                    .map((_, i) => <td key={`empty-${i}-${day}-${hourKey}`}></td>)}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };



  const generateClosingOptions = () => {
    if (!timeSlots.starttime || !selectedDay) return [];

    const isRegular = isActive === "regular";
    const dayToUse = isRegular ? selectedDay : dayName;
    const currentDayIndex = days.indexOf(dayToUse);

    const openIndex = hours.indexOf(timeSlots.starttime.trim());
    if (openIndex === -1) return [];

    // Prepare disabled ranges from selected slots
    const disabledRanges = selectedSlots
      .map(slot => {
        const startIdx = hours.indexOf(slot.starttime.trim());
        let endIdx = hours.indexOf(slot.endtime.replace(/\s*\(\w+\)/, "").trim());

        const spansNextDay = endIdx < startIdx;
        if (spansNextDay) endIdx += hours.length;

        return { startIdx, endIdx, spansNextDay };
      })
      .filter(({ startIdx, endIdx }) => startIdx !== -1 && endIdx !== -1);

    // console.log("Disabled Ranges:", disabledRanges);

    let closingOptions = [];

    // Find earliest conflict *after* start time
    let maxCloseIndex = openIndex + hours.length;
    for (let { startIdx } of disabledRanges) {
      if (startIdx > openIndex && startIdx < maxCloseIndex) {
        maxCloseIndex = startIdx;
      }
    }

    // Closing options for current day
    closingOptions = hours.map((time, i) => ({
      time,
      label: `${time} (${dayToUse})`,
      disabled: i <= openIndex || i >= maxCloseIndex,
    }));

    // Closing options for the next day
    const nextDay = days[(currentDayIndex + 1) % days.length];
    closingOptions.push(
      ...hours.map((time, i) => ({
        time,
        label: `${time} (${nextDay})`,
        disabled: i > maxCloseIndex - hours.length,
      }))
    );

    // console.log("Final Closing Options:", closingOptions);
    return closingOptions;
  };



  const closingOptions = generateClosingOptions();

  const loginType = localStorage.getItem('login_type'); // 'admin' or 'client'
  const useruniqueid = localStorage.getItem("clientid")


  const handleClose = () => {
    setShowPoup(false)
    setTimeSlots({
      starttime: '',
      endtime: ''
    })
    setSelectedSlots([])
    setWorkingHours([])
    setSingleDayData([])
    setCategoryHours([])
    setPlans(plansData)
    setSelectedDate(null)
    setShowSpecialHours(false)
    setSingleSplData({})
  }
  const handleDayClick = (day) => {
    const formattedDay = day.trim().toUpperCase(); // Convert to uppercase for consistency

    const filteredSpots = spotsData.filter(
      (spot) => spot.spotday === formattedDay
    );
    const dayInCaps = day // example input
    const formattedDay1 = dayInCaps.charAt(0) + dayInCaps.slice(1).toLowerCase();
    // console.log('hanlde day click', day)
    // setSelectedDay(formattedDay1)
    setSelectedDay(day)
    setSelectedDays([day])
    setSingleSpot(filteredSpots);
    setIsOpen(filteredSpots?.[0]?.isopen)
    // console.log("Filtered Spots:", filteredSpots);
  };

  const handleAddWork = () => {
    if (isActive === "regular") {
      setShowPoup(true)
    } else {
      setShowSpecialHours(true)
    }

  }
  // console.log("selectedddddddddddddddd--------->", selectedDay)
  // console.log("selecteddddddddddddddddNEwwwwwww--------->", selectedDayNew)
  // console.log('pricePerSpot',pricePerSpot)
  // console.log('maxvistiore',maxVisitors)
  useEffect(() => {
    getStore()
    userActivity()
  }, [])
  useEffect(() => {
    // console.log("Updated Selected Days:", selectedDays);
  }, [selectedDays]);
  useEffect(() => {

    if (window.site === undefined) {
      setTimeout(() => {
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
          setImg(window.site.common.imageCloudfront)
        }
      }, 1000);
    }
    if (window.site && window.site.common && window.site.common.imageCloudfront) {
      setImg(window.site.common.imageCloudfront)
    }



  }, [window.site]);


  const handlePlanSdata = (e) => {
    console.log("e.target.value---------------------->", e.target.value)
  }



  const handleAddSlot = () => {
    if (!timeSlots.starttime || !timeSlots.endtime) {
      alert("Please select a valid time slot.");
      return;
    }

    setSelectedSlots((prevSlots) => {
      let updatedSlots;
      let newSlotId = timeSlots.id || (prevSlots.length > 0 ? Math.max(...prevSlots.map(slot => slot.id)) + 1 : 1);

      if (timeSlots.id) {
        // Update existing slot
        updatedSlots = prevSlots.map(slot =>
          slot.id === timeSlots.id ? { ...slot, starttime: timeSlots.starttime, endtime: timeSlots.endtime } : slot
        );
      } else {
        // Create a new slot with a unique ID
        const newSlot = {
          id: newSlotId,
          starttime: timeSlots.starttime,
          endtime: timeSlots.endtime
        };
        updatedSlots = [...prevSlots, newSlot];
      }

      setPlans((prevPlans) => {
        if (timeSlots.id) {

          return prevPlans.map(plan =>
            plan.id === timeSlots.id ? { ...plan, starttime: timeSlots.starttime, endtime: timeSlots.endtime } : plan
          );
        }

        if (prevSlots.length === 0) {
          // First slot: Modify only the first two default objects
          return prevPlans.map((plan, index) =>
            index < 2 ? { ...plan, starttime: timeSlots.starttime, endtime: timeSlots.endtime, id: newSlotId } : plan
          );
        }

        // Subsequent slots: Create new objects for each base plan
        const basePlans = prevPlans.slice(0, 2); // First two objects are the base plans

        // Ensure the new slot is not already added
        const isSlotAlreadyAdded = prevPlans.some(
          plan => plan.starttime === timeSlots.starttime && plan.endtime === timeSlots.endtime
        );

        if (isSlotAlreadyAdded) return prevPlans; // Prevent duplicates

        const newSlotPlans = basePlans.map(plan => ({
          ...plan,
          starttime: timeSlots.starttime,
          endtime: timeSlots.endtime,
          id: newSlotId
        }));

        return [...prevPlans, ...newSlotPlans];
      });

      return updatedSlots;
    });

    setTimeSlots({ starttime: "", endtime: "" });

  };





  // console.log("planssssssssssssssssssssssss", plans)
  // console.log("selectedSlotsssssssssssssssssssssssss", selectedSlots)

  const handleDeleteSlot = (data) => {
    const updatedSlots = selectedSlots.filter((item) => item?.id !== data?.id);
    setSelectedSlots(updatedSlots);
    const updatedPlans = plans.map((item) => {
      if (
        item?.id === data?.id &&
        item?.starttime === data?.starttime &&
        item?.endtime === data?.endtime
      ) {
        const { starttime, endtime, ...rest } = item;
        return rest; // return object without starttime and endtime
      }
      return item; // return unchanged
    });

    setPlans(updatedPlans);
  };

  const handleDaySelect = (day) => {
    setSelectedDays((prevDays) => {
      if (prevDays.includes(day)) {
        // If day exists, remove it
        return prevDays.filter((d) => d !== day);
      } else {
        // Otherwise, add it
        return [...prevDays, day];
      }
    });
  };
  // console.log('singleDayData', singleDayData)
  const handleIsStoreOpen = (isopenvalue = null, storespotdayid) => {
    setLoaderEnable(true)
    // setCommonLoader(true)
    // console.log('isopenvalue', isopenvalue)
    // console.log('storespotdayid', storespotdayid)
    const token = localStorage.getItem("token");
    const payload = {
      storeid: formData?.storeid,
      spotdaystartend: singleSpot?.[0]?.spotdaystartend,
      spotdayplanstartend: singleSpot?.[0]?.spotdayplanstartend,
      createdBy: {
        userId: userData?.clientid,
      },
    };

    // Set the `isOpen` state if provided
    if (isopenvalue !== null) {
      setIsOpen(isopenvalue);
      payload.isopen = isopenvalue; // Add the `isopen` value to the payload if it's not null
    }

    // Handle payload specifics based on the spot type
    if (isActive === 'regular') {
      payload.spotstype = "REGULAR";

    } else {
      payload.spotstype = "SPECIAL";
      payload.days = [dayName];
    }

    // Construct the URL for the API
    const url = `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${storespotdayid}`;

    // Make the API request
    axios({
      method: 'POST',
      url: url,
      data: payload,
    })
      .then(function (response) {
        if (response) {
          if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true);
          } else {
            getSpots(formData?.storeid);
            setSelectedSlots([]);
            setPlans([]);
            // setSelectedDate(null);
          }

        }
      })
      .catch((error) => {
        console.error("Error updating store open status:", error);
      });
  };
  // console.log('selectdaysssssssssss',selectedDays)


  const handleCalender = () => {
    if (workingHours.length <= 0) {
      setToastMessage("Enter working hours to proceed.");
      setToastType("error");
      return;
    }
    // GetTimeActivity()   
    // setBtnLoader(true)
    setLoaderEnable(true);
    // console.log('handle addd', selectedSlots)
    const token = localStorage.getItem("token");
    let payload = {};

    // // Cleaning `plans` to remove "(Monday)" from `endtime`
    // const cleanedPlans = plans.map(plan => ({
    //   ...plan,
    //   endtime: plan.endtime  // Ensures `endtime` is valid
    // }));



    // const cleanSelectPlans = selectedSlots.map(slot => ({
    //   ...slot,
    //   endtime: slot.endtime
    // }));

    if (isActive === 'regular') {
      payload = {
        storeid: formData?.storeid,
        spotstype: "REGULAR",
        spotdaystartend: workingHours,
        spotdayplanstartend: categoryHours,
        createdBy: {
          userId: userData?.clientid
        },
        days: selectedDays
      };
      // if (!singleDayData?.storespotdayid) {
      //   payload.days = selectedDays;
      // }

    } else {
      payload = {
        storeid: formData?.storeid,
        spotstype: "SPECIAL",
        spotdaystartend: workingHours,
        spotdayplanstartend: categoryHours,
        spotspecialfromdate: selectedDate,
        spotspecialtodate: selectedDate,
        createdBy: {
          userId: userData?.clientid
        },
        days: [dayName]
      };
    }

    // if (selectedSlots?.length > 0) {

    const url = selectedDays?.length > 1 && singleDayData?.storespotdayid ? `${lambda}/updateSpots?appname=${appname}&token=${token}&schedule_days=${true}`
      : singleDayData?.storespotdayid || singleSplData?.storespotdayid
        ? `${lambda}/updateSpots?appname=${appname}&token=${token}&storespotdayid=${singleDayData?.storespotdayid ?? singleSplData?.storespotdayid}`
        : `${lambda}/addSpots?appname=${appname}&token=${token}`;

    axios({
      method: 'POST',
      url: url,
      data: payload,
    })
      .then(function (response) {
        if (response) {
          if (response?.result === "Invalid token or Expired") {
            setShowSessionPopupup(true)
          } else {
            getSpots(formData?.storeid)
            setSelectedSlots([])
            setPlans([])


          }

        }

      });
    setShowcalender(true)

    // Add your save logic here.
    // }
  }



  const handleChange = (selected) => {
    setSelectedOptions(selected);
  };

  const handleClick = (value) => {
    setIsActive(value)
  }
  // console.log("timeSlotsssssssssssssssssssssssssssssssssssssssssssss", timeSlots)
  // console.log("single day data", singleDayData)
  const handleEditHour = (data) => {
    // console.log("datatatatatatatatatatatattatatatata", data)
    setSingleDayData(data?.[0])
    setSelectedDay(
      data?.[0]?.spotday
      // ? data[0].spotday.charAt(0).toUpperCase() + data[0].spotday.slice(1).toLowerCase()
      // : ''
    );
    setSelectedDays([data?.[0]?.spotday])
    setPlans(data?.[0]?.spotdayplanstartend)
    setSelectedSlots(data?.[0]?.spotdaystartend)
    setWorkingHours(data?.[0]?.spotdaystartend)
    setCategoryHours(data?.[0]?.spotdayplanstartend)
    setShowPoup(true)
  }
  const handleBack = () => {
    navigate("/spots")
  }
  const handleEditTime = (data) => {
    // console.log("datatatatatatatattata", data)
    setTimeSlots(data)
  }
  const handleEditPlanTime = (plan) => {
    setEditingPlans(prev => {
      const updated = {
        ...prev,
        [plan.plan]: plan,
      };
      // console.log("Edited Plans:", updated);
      return updated;
    });
  };

  const handleAddPlan = (data) => {
    // console.log("DATATATATATTATATAATATATATA", data)
    const updatedValues = editingPlans[data.name]; // data.name = "Premium"
    // console.log("UpdatedValuesssssssssssssssssssssssssssssssssssssssssssssssssssss", updatedValues)
    setPlans((prevPlans) =>
      prevPlans.map((plan) =>
        plan.id === updatedValues.id && plan.plan === data.name
          ? { ...plan, ...updatedValues }
          : plan
      )
    );

    // Clean up editingPlans
    setEditingPlans((prev) => {
      const updated = { ...prev };
      delete updated[data.name];
      return updated;
    });
  };

  // console.log('activeCategoryIndex',activeCategoryIndex)

  const handleEditChange = (e, planName) => {
    const { name, value } = e.target;
    // console.log("valueeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", value)
    setEditingPlans((prev) => ({
      ...prev,
      [planName]: {
        ...prev[planName],
        [name]: value, // value already includes time + (Day)
      },
    }));
  };





  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };



  const handleDateClick = (data) => {
    // console.log("datatatata-------------------------------->", data)
    setSingleSplSpot(data)
  }

  const handleAddSpot = () => {
    setShowSpecialHours(true)
  }

  // console.log("editinggggggPlan", editingPlans)
  const getStore = (e) => {
    setIsLoading(true)
    // GetTimeActivity()
    const token = localStorage.getItem("token")
    axios({
      method: 'POST',
      url: `${lambda}getStores?appname=${appname}&userid=${useruniqueid}&storeid=${id}&token=${token}`,
      // + "&token=" + token,
    })
      .then(function (response) {
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          if (response?.data?.result) {
            const result = response?.data?.result?.[0];
            setFormData(result)
            getSpots(result?.storeid)

            if (result?.preferences) {
              const activePlans = Object.values(result.preferences).filter(plan => plan.active); // Extract only active plans

              const FindMembers = Object.keys(result?.preferences || {}).reduce((acc, key) => {
                const item = result.preferences[key];
                if (item?.name) {
                  acc[item.name] = Math.floor((item?.percentage / 100) * result?.maxVisitor);
                }
                return acc;
              }, {});
              // console.log("FindMemberssssssssssssssssssssssssssssss", FindMembers)
              const formattedPlans = activePlans.map(plan => {

                const maxVisitors = FindMembers[plan.name] !== undefined ? FindMembers[plan.name] : 0;
                return {
                  plan: plan.name || "",
                  price: Number(plan.price) || 0,
                  maxvisitors: maxVisitors,
                };
              });
              // console.log('formattedPlans', formattedPlans)
              setPlansData(formattedPlans)
              // setHourCategories({...hourCategories,...formattedPlans })
              // Mapping from plan names to hour category labels
              const planToCategoryName = {
                Basic: "BASIC HOURS",
                Premium: "PREMIUM HOURS",
                VIP: "VIP HOURS"
              };

              const newHourCategories = formattedPlans.map(plan => ({
                name: planToCategoryName[plan.plan] || plan.plan.toUpperCase() + " HOURS",
                hours: [],
                ...plan
              }));
              setHourCategories(newHourCategories);



              // Mapping formattedPlans to categoryTypes format
              const updatedCategoryTypes = formattedPlans.map(plan => {
                return {
                  name: `${plan.plan.toUpperCase()} HOURS`, // Adjust name formatting as needed
                  plan: plan.plan,
                  price: plan.price,
                  maxvisitors: plan.maxvisitors
                };
              });

              // Update the state
              setCategoryTypes(updatedCategoryTypes);
              // console.log(updatedCategoryTypes);
              setPlans(formattedPlans);

            }



          } else {
            // setInvalidContent(true)
          }

        }

        // setDisableSaveBtn(false)
      });
  }
  // console.log("singleSpotttttttttttttttttttttttttttttttt", spotsData)



  // When showSpecialHours becomes false
  useEffect(() => {
    if (!showSpecialHours && !showPopup) {
      setWorkingHours([]);
      setCategoryHours([]);
      setActiveCategoryIndex(0);
      setEditMode(false);
      setSingleDayData([]);
      setSelectedStartTime("");
      setSelectedEndTime("");
      setSingleSplData({});
      setSelectedDate(null)
      setPricePerSpot(0);
      setMaxVisitors(0);
      setCategoryEditMode(false);
    }
  }, [showSpecialHours, showPopup]);

  const handleEditSpecial = (data) => {
    setSingleSplData(data)
    setWorkingHours(data?.spotdaystartend)
    setCategoryHours(data?.spotdayplanstartend)
    setSelectedDate(data?.spotspecialfromdate)
    //    let day = date.toLocaleDateString('en-US', { weekday: 'long' });
    // const formattedDay = day.trim().toUpperCase();
    setSelectedDay(data?.spotday)
    setDayName(data?.spotday);
    setShowSpecialHours(true)
    // console.log("datatatatatatatatatatatta", data)

  }
  const getSpots = (Id) => {
    setLoaderEnable(true)
    const token = localStorage.getItem("token")
    axios({
      method: 'GET',
      url: lambda + '/getSpots?appname=' + appname + "&storeid=" + Id + "&token=" + token,
    })
      .then(function (response) {
        if (response?.data?.result === "Invalid token or Expired") {
          setShowSessionPopupup(true)
        } else {
          const result = response?.data?.result?.filter((item) => item?.spotstype === "REGULAR")
          const filterSpotDay = result?.filter((day) => day?.spotday === selectedDay)
          // console.log("filterSpotDay---->", spotDay, filterSpotDay)
          setSpotsData(result)

          // console.log("Resulttttttttttttttttttttttttttttttttttttttttttttttttttttt",result?.length)
          // setSingleSpot(filterSpotDay)
          // setTimeout(() => {
          setSingleSpot(filterSpotDay);
          setIsOpen(filterSpotDay?.[0]?.isopen)
          // setCommonLoader(false)
          setLoaderEnable(false)
          // }, 1000);
          const specialSpots = response?.data?.result?.filter((day) => day?.spotstype === "SPECIAL")
          // console.log("specialSpots------------------------->", specialSpots)
          setSpecialSpotData(specialSpots)
          setSingleSplSpot(specialSpots?.[0])
          setIsLoading(false)
          // console.log('singleSplSpotttttttttttttttttttttttttttttttttttttttttttttt',specialSpots?.[0])
          setShowPoup(false)
          setShowSpecialHours(false)
          setLoaderEnable(false)

        }

      }).catch((err) => {
        console.log('error', err);

      });
  }
  useEffect(() => {
    // console.log('singleSpot------------------------->', singleSpot)
  }, [singleSpot])
  // console.log('selectday', selectedDay)
  // console.log('spotday', spotDay)
  return (

    <>
      {showSessionPopupup && <SessionPopup />}
      <div id="layout-wrapper">
        <Header />
        <Sidebar />

        {/* Start right Content here  */}
        {isLoading && !loaderEnable ? <Loader /> :
          <div className="main-content user-management spots">

            <div className="page-content">
              <div className="container-fluid">



                <div className="row  breadcrumb">
                  <div className="col-lg-12">
                    <div className="d-flex align-items-center">

                      <div className="flex-grow-1">
                        <h4 className="mb-2 card-title">Spots</h4>

                      </div>
                      {/* {subValDashboard && subValDashboard.Add && subValDashboard.Add.display === true && */}
                      <div>
                        <button className="fill-btn-style"
                          id="back-button"
                          onClick={handleBack}
                        //  disabled={subValDashboard && subValDashboard.Add && subValDashboard.Add.enable === false}
                        >Back</button>
                      </div>
                      {/* } */}
                    </div>
                  </div>
                </div>

                <div className="row manage-hours">
                  <div className="col-12 Add-store-block">
                    <div className="card">
                      <div className="card-body d-flex align-items-center">
                        <h4 className="form-title mb-0" id="location-info-title">SELECT STORE</h4>
                        <div class="input-group">

                          <select id="store-name" name="name" value={formData?.name} className="multi-select-style">

                            <option value={formData?.name}>{formData?.name}</option>
                          </select>
                        </div>
                        {/* <button class="fill-btn save_continue">ADD</button> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row table-data">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <ul className="nav nav-tabs nav-tabs-custom" role="tablist" id="tab-navigation">
                          <li className="nav-item" role="presentation" id="tab-regular-hours" style={{ cursor: "pointer" }} onClick={() => handleClick("regular")}>
                            <a className={`nav-link ${isActive === "regular" ? "active" : ""}`} id="link-regular-hours">
                              <span className="material-symbols-outlined">schedule</span>
                              <span className="d-none d-sm-block">REGULAR HOURS</span>
                            </a>
                          </li>

                          <li className="nav-item" role="presentation" id="tab-special-hours" style={{ cursor: "pointer" }} onClick={() => handleClick("special")}>
                            <a className={`nav-link ${isActive === "special" ? "active" : ""}`} id="link-special-hours">
                              <span className="material-symbols-outlined">kid_star</span>
                              <span className="d-none d-sm-block">SPECIAL HOURS</span>
                            </a>
                          </li>
                        </ul>

                        {/* spots tab start */}



                        {/* spots tab Start */}
                        <div className="tab-content p-3 text-muted">

                          {/* REGULAR HOURS TAB */}
                          <div className={`tab-pane ${isActive === "regular" ? "active show" : ""} weekly-section`}
                            id="home1" role="tabpanel">

                            {/* Weekend tab start */}

                            {/* Weekend Monday */}

                            {spotsData?.length > 0 ? loaderEnable ? <>
                              <Loader />
                            </> : !loaderEnable && (
                              <>
                                <ul className="nav nav-pills weekly-wrapper" id="pills-tab" role="tablist">
                                  {daysOfWeek.map(day => (
                                    <li className="nav-item" role="presentation" key={day}>
                                      <button
                                        onClick={() => handleDayClick(day)}
                                        className={`nav-link week-btn ${selectedDay === day ? 'active' : ''}`}
                                        id={`pills-${day}-tab`}
                                        data-bs-toggle="pill"
                                        data-bs-target={`#Week-${day}`}
                                        type="button"
                                        role="tab"
                                      >
                                        {day}
                                      </button>
                                    </li>
                                  ))}
                                </ul>

                                {singleSpot?.length > 0 ? (
                                  <div className="tab-pane fade show active" id="Week-Mon" role="tabpanel" aria-labelledby="Week-Mon">
                                    <div className="row store">
                                      <div className="col-md-3">
                                        {/* left side store panel */}
                                        <div className="store-panel-left">
                                          <div className="d-flex align-items-center justify-content-between">
                                            <h4 className="form-title mb-0" id="location-info-title">STORE WORKING HOURS</h4>

                                            <div className="input-field switch-buttons d-flex align-items-center">
                                              <label className="col-form-label p-0 me-2">Store {isOpen ? 'Open' : 'Closed'}</label>
                                              <label className="switch disable mb-0">
                                                <Tooltip title={isOpen ? "Click to close the store" : "Click to open the store"}>  <input
                                                  type="checkbox"
                                                  id="store-open-checkbox"
                                                  checked={isOpen}
                                                  disabled={loaderEnable}
                                                  title='kkkkk'
                                                  //  title={isOpen ? "Click to close the store" : "Click to open the store"}
                                                  onChange={() => handleIsStoreOpen(!isOpen, singleSpot?.[0]?.storespotdayid)}
                                                />
                                                  <span className="slider round"></span>
                                                </Tooltip>
                                              </label>

                                              {/* <small className="text-muted">Toggle to set the store as open or closed.</small> */}

                                            </div>

                                          </div>
                                          {singleSpot?.[0]?.spotdaystartend?.map((item, index) => (
                                            <button
                                              key={index}
                                              className="time-fill-btn w-100 mt-4 d-flex align-items-center justify-content-center"
                                              id={`time-btn-${index}`}
                                            >
                                              <span className="material-symbols-outlined me-2">schedule</span>
                                              {/* {`${item?.starttime} (${singleSpot?.[0]?.spotday?.slice(0, 3).toUpperCase()}) to ${item?.endtime?.replace(/\((\w+)\)/, (_, day) => `(${day.slice(0, 3).toUpperCase()})`)}`} */}

                                              {`${formatTimeForDisplay(item?.starttime, item?.day)} to ${formatTimeForDisplay(item?.endtime, item?.endDay)}`}
                                              {/* {`${item?.openTimeDisplay} to ${item?.closeTimeDisplay}`} */}



                                            </button>

                                          ))}
                                          <button
                                            className="outline_btn d-flex align-items-center justify-content-center mt-4"
                                            id="edit-hours-btn"
                                            onClick={() => handleEditHour(singleSpot)}
                                          >
                                            <span className="material-symbols-outlined me-2">edit_calendar</span>Edit Hours
                                          </button>
                                        </div>
                                      </div>

                                      {/* right side store panel */}
                                      <div className="col-md-9 ps-1">
                                        <div className="store-panel-right">
                                          <div style={{ height: 500 }} className="calander-block">
                                            {singleSpot?.[0]?.isopen === false ?
                                              <div className="container text-center" id="store-closed-message">
                                                <div className="image-container">
                                                  <img
                                                    src={`${image}${appname}/images/web/Store-Closed.svg`}
                                                    alt="No spots available"
                                                    className="img-fluid"
                                                    style={{ maxWidth: "300px" }}
                                                    id="store-closed-image"
                                                  />
                                                </div>
                                                <h5 className="mt-3 fw-bold" id="store-closed-title">Store is closed today</h5>
                                                <p className="text-muted" id="store-closed-info"> Set store to open.</p>
                                              </div> :

                                              <>
                                                <h4 className="form-title mb-0" id="paid-plans-title">PAID PLANS</h4>


                                                {uniqueDays.length > 0 ? (
                                                  uniqueDays.map(day => renderCalendarForDay(day))
                                                ) : (
                                                  <p>No slots available</p>
                                                )}
                                              </>
                                            }
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ) :


                                  !commonLoader && (
                                    <div className="container text-center" id="store-closed-message">
                                      <div className="image-container">
                                        <img
                                          src={`${image}${appname}/images/web/Store-Closed.svg`}
                                          alt="No spots available"
                                          className="img-fluid"
                                          style={{ maxWidth: "300px" }}
                                          id="store-closed-image"
                                        />
                                      </div>
                                      <h5 className="mt-3 fw-bold" id="store-closed-title">Store is closed today</h5>
                                      <p className="text-muted" id="store-closed-info">Add working hours to get started</p>
                                      <button
                                        className="stroke-button"
                                        id="add-store-button"
                                        onClick={handleAddWork}
                                        style={{ display: "inline-flex" }}
                                      >
                                        <span className="material-symbols-outlined">add_circle</span>ADD WORKING HOURS
                                      </button>
                                    </div>
                                  )}
                              </>
                            ) : !loaderEnable && (
                              <div className="container text-center" id="no-spots-set">
                                <div className="image-container">
                                  <img
                                    src={`${image}${appname}/images/landingPage/spots-default-img.svg`}
                                    alt="No spots available"
                                    className="img-fluid"
                                    style={{ maxWidth: "300px" }}
                                    id="no-spots-image"
                                  />
                                </div>
                                <h5 className="mt-3 fw-bold" id="no-spots-title">No Spots Set Yet!</h5>
                                <p className="text-muted" id="no-spots-info">Add stores to get started</p>
                                <button
                                  className="stroke-button"
                                  id="add-store-button"
                                  onClick={handleAddWork}
                                  style={{ display: "inline-flex" }}
                                >
                                  <span className="material-symbols-outlined">add_circle</span>ADD WORKING HOURS
                                </button>
                              </div>
                            )}

                          </div>


                          {/* SPECIAL HOURS TAB */}
                          <div className={`tab-pane ${isActive === "special" ? "active show" : ""}`} id="home1" role="tabpanel">
                            {SpecialSpotData?.length > 0 ? (
                              <div className={`tab-pane ${isActive === "special" ? "active show" : ""}`} id="home1" role="tabpanel">
                                <div className="row store" id="store-container">
                                  <div className="col-md-3" id="left-store-panel">
                                    {/* left side store panel */}
                                    <div className="store-panel-left" id="store-panel-left">
                                      <div className="d-flex align-items-center justify-content-between">
                                        <h4 className="form-title mb-0" id="location-info-title">STORE WORKING HOURS</h4>
                                        <button className="stroke-btn-style" onClick={handleAddSpot} id="add-spot-button">
                                          <span className="material-symbols-outlined">add</span>Add
                                        </button>
                                      </div>

                                      <div className="d-flex align-items-start">
                                        <div className="nav nav-pills special-hours-wrp-section mt-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
                                          {SpecialSpotData?.map((item) => {
                                            const data = item;
                                            return (
                                              <div
                                                className={item?.spotspecialfromdate === singleSplSpot?.spotspecialfromdate ? "nav-link special-hours-wrapper active" : "nav-link special-hours-wrapper"}
                                                data-bs-toggle="pill"
                                                data-bs-target="#special-hours-1"
                                                role="tab"
                                                aria-controls="special-hours-1"
                                                aria-selected="true"
                                                onClick={() => handleDateClick(item)}
                                                id={`special-hours-item-${item?.spotspecialfromdate}`}
                                              >
                                                <div className="d-flex align-items-center special-hours-header mb-3">
                                                  <h4 className="form-title mb-0">{formatDate(item?.spotspecialfromdate)}</h4>
                                                  <div className="d-flex align-items-center">
                                                    <span className="material-symbols-outlined" onClick={() => handleEditSpecial(item)}>edit</span>
                                                    <span className="material-symbols-outlined">delete</span>
                                                  </div>
                                                </div>
                                                {item?.spotdaystartend?.map((item) => {
                                                  return (
                                                    <button className="time-fill-btn d-flex align-items-center justify-content-center" id={`time-slot-${item?.starttime}-${item?.endtime}`}>
                                                      <span className="material-symbols-outlined me-2">schedule</span>
                                                      {/* {item?.starttime} ({data?.spotday?.slice(0, 3)}) to {item?.endtime} ({data?.spotday?.slice(0, 3)}) */}
                                                      {`${formatTimeForDisplay(item?.starttime, item?.day)} to ${formatTimeForDisplay(item?.endtime, item?.endDay)}`}
                                                    </button>
                                                  );
                                                })}
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  {/* right side store panel */}
                                  <div className="col-md-9 ps-1" id="right-store-panel">
                                    <div className="store-panel-right" id="store-panel-right">
                                      <div className="tab-content" id="v-pills-tabContent">
                                        <div className="store-panel-right">
                                          <div style={{ height: 500 }} className="calander-block" id="calendar-block">
                                            <h4 className="form-title mb-0" id="special-date-title">
                                              <span>{formatDate(singleSplSpot?.spotspecialfromdate)}</span> PAID PLANS
                                            </h4>

                                            {uniqueDays.length > 0 ? (
                                              uniqueDays.map(day => renderCalendarForDay(day))
                                            ) : (
                                              <p>No slots available</p>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <div className="container text-center" id="no-spots-container">
                                <div className="image-container" id="no-spots-image">
                                  <img
                                    src="https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/landingPage/spots-default-img.svg"
                                    alt="No spots available"
                                    className="img-fluid"
                                    style={{ maxWidth: "300px" }}
                                    id="no-spots-img"
                                  />
                                </div>
                                <h5 className="mt-3 fw-bold" id="no-spots-title">No Spots Set Yet!</h5>
                                <p className="text-muted" id="no-spots-text">Add stores to get started</p>
                                <button className="fill-btn-style" id="add-store-button" onClick={handleAddWork} style={{ display: "inline-flex" }}>
                                  <span className="material-symbols-outlined">add_circle</span>ADD
                                </button>
                              </div>
                            )}
                          </div>


                        </div>
                        {/* spots tab Stop */}

                      </div>

                      <Modal className="add_hours" show={showPopup}>
                        <div className="modal-header">
                          <div className="add_hours_title">
                            <div className="modal-title h4">ADD HOURS</div>
                            <div className="max_visitor">
                              <div className="max_visitor_status" id="max-visitor-status">
                                {`Max Visitors / Spot ${formData?.maxVisitor}`}
                              </div>
                              <div className="max_visitor_status" id="max-party-size">
                                {`Max Party size / Spot ${formData?.maxPartySize}`}
                              </div>
                              <div className="max_visitor_status" id="max-location-capacity">
                                {`Max Capacity / Day ${formData?.maxLocationCapacity}`}
                              </div>

                            </div>
                          </div>
                          <button type="button" className="close-btn"
                            // onClick={() => setShowModal(false)}
                            onClick={handleClose} id="spots-close-button">
                            <span className="material-icons">close</span>
                          </button>
                        </div>

                        <div className="modal-body">
                          <div className="working_hours premium_hours">
                            <h6>SET STORE WORKING HOURS</h6>
                          </div>

                          <div className="table-responsive">
                            <table className="table align-middle">
                              <thead>
                                <tr>
                                  <th width="30%">
                                    <div className="form-group">
                                      <label className="form_label" id="day-label">Select Day</label>
                                      <select
                                        className="form-select"
                                        value={selectedDay}
                                        onChange={(e) => {
                                          setSelectedDay(e.target.value);
                                          setSelectedStartTime('');
                                          setSelectedEndTime('');
                                          setSelectedDays([e.target.value])
                                        }}
                                        disabled={workingHours?.length > 0 || spotsData?.length > 0}
                                        id="select-day-label"
                                      >
                                        {daysOfWeek.map(day => (
                                          <option key={day} value={day}>{day}</option>
                                        ))}
                                      </select>
                                    </div>
                                  </th>
                                  <th width="30%">
                                    <div className="form-group">
                                      <label className="form_label" id="open-label">Opens</label>
                                      <select
                                        className="form-select"
                                        value={selectedStartTime}
                                        onChange={(e) => setSelectedStartTime(e.target.value)}
                                        id="spots-open-select"
                                      >
                                        <option value="">Select Open Time</option>
                                        {getStartTimeOptions().map(time => (
                                          <option key={time.value} value={time.value}>
                                            {time.displayValue}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </th>
                                  <th width="30%">
                                    <div className="form-group">
                                      <label className="form_label" id="close-label">Closes</label>
                                      <select
                                        key={endTimeKey}
                                        className="form-select"
                                        value={selectedEndTime}
                                        onChange={(e) => setSelectedEndTime(e.target.value)}
                                        disabled={!selectedStartTime}
                                        id="spots-close-select"
                                      >
                                        <option value="">Select Close Time</option>
                                        {getEndTimeOptions().map(time => (
                                          <option key={time.value} value={time.value}>
                                            {time.displayValue}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </th>
                                  <th width="10%" className="right">
                                    <button
                                      className="fill-btn-style"
                                      id="save-button"
                                      onClick={handleAddWorkingHours}
                                    // disabled={!selectedStartTime || !selectedEndTime}
                                    >
                                      <span className="material-symbols-outlined">
                                        {editMode ? 'edit' : 'add_circle'}
                                      </span>
                                      {editMode ? 'update' : 'add'}
                                    </button>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>

                                {workingHours?.map((hour) => (
                                  <tr key={hour.id}>
                                    <td>{hour.day}</td>
                                    <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                    <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                    <td className="right">
                                      <button className="btn btn-link p-0 me-2" onClick={() => handleEditWorkingHours(hour.id)} id="spots-edit-button">
                                        <span className="material-symbols-outlined">edit</span>
                                      </button>
                                      <button className="btn btn-link p-0" onClick={() => handleDeleteWorkingHours(hour.id)} id="spots-delete-button">
                                        <span className="material-symbols-outlined">delete</span>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>

                          {categoryTypes?.map((category, categoryIndex) => (
                            <div key={categoryIndex}>
                              <div className="working_hours premium_hours">
                                <h6 style={{ cursor: 'pointer' }} onClick={() => setActiveCategoryIndex(categoryIndex)}>{category.name}</h6>

                              </div>
                              <div className="table-responsive">
                                <table className="table align-middle">
                                  <thead>
                                    <tr>
                                      <th width="25%">
                                        <div className="form-group">
                                          <label className="form_label" id="category-open-label">Opens</label>
                                          <select
                                            className="form-select"
                                            value={categoryIndex === activeCategoryIndex ? selectedCategoryStartTime : ''}
                                            onChange={(e) => {
                                              if (categoryIndex !== activeCategoryIndex) {
                                                setActiveCategoryIndex(categoryIndex);
                                              }
                                              setSelectedCategoryStartTime(e.target.value);
                                              setSelectedCategoryEndTime('');
                                            }}
                                            disabled={categoryIndex !== activeCategoryIndex}
                                            id="spots-category-opens"
                                          >
                                            <option value="">Select Open Time</option>
                                            {categoryIndex === activeCategoryIndex && getCategoryStartTimeOptions().map(time => (
                                              <option key={time.value} value={time.value}>
                                                {time.displayValue}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </th>
                                      <th width="25%">
                                        <div className="form-group">
                                          <label className="form_label" id="category-close-label">Closes</label>
                                          <select
                                            key={categoryEndTimeKey}
                                            className="form-select"
                                            value={categoryIndex === activeCategoryIndex ? selectedCategoryEndTime : ''}
                                            onChange={(e) => setSelectedCategoryEndTime(e.target.value)}
                                            disabled={!selectedCategoryStartTime || categoryIndex !== activeCategoryIndex}
                                            id="spots-category-close"
                                          >
                                            <option value="">Select Close Time</option>
                                            {categoryIndex === activeCategoryIndex && selectedCategoryStartTime && getCategoryEndTimeOptions().map(time => (
                                              <option key={time.value} value={time.value}>
                                                {time.displayValue}
                                              </option>
                                            ))}
                                          </select>
                                        </div>
                                      </th>
                                      <th width="20%">
                                        <div className="form-group">
                                          <label className="form_label" id="max-visitors-label">Max Visitors / Spot</label>
                                          <input
                                            className="form-control"
                                            placeholder="Enter"
                                            type="text"
                                            value={categoryIndex === activeCategoryIndex ? maxVisitors : ''}
                                            onChange={(e) => setMaxVisitors(e.target.value)}
                                            disabled={categoryIndex !== activeCategoryIndex}
                                          />
                                        </div>
                                      </th>
                                      <th width="20%">
                                        <div className="form-group">
                                          <label className="form_label" id="price-label">Price / Spot</label>
                                          <input
                                            className="form-control"
                                            placeholder="00.00"
                                            type="text"
                                            value={categoryIndex === activeCategoryIndex ? pricePerSpot : ''}
                                            onChange={(e) => setPricePerSpot(e.target.value)}
                                            disabled={categoryIndex !== activeCategoryIndex}
                                          />
                                        </div>
                                      </th>
                                      <th width="10%" className="right">
                                        <button
                                          className="fill-btn-style"
                                          id="save-button"
                                          onClick={handleAddCategoryHours}
                                          // disabled={!selectedCategoryStartTime || !selectedCategoryEndTime || categoryIndex !== activeCategoryIndex}
                                         // disabled={!isMaxVisitorsValid()}
                                          disabled={categoryIndex !== activeCategoryIndex}
                                        >
                                          <span className="material-symbols-outlined">
                                            {categoryEditMode && categoryIndex === activeCategoryIndex ? 'edit' : 'add_circle'}
                                          </span>
                                          {categoryEditMode && categoryIndex === activeCategoryIndex ? 'update' : 'add'}
                                        </button>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>

                                    {categoryHours?.filter(hour => hour.plan === category.plan)?.map((hour, idx) => (
                                      <tr key={`${hour.id}-${idx}`}>
                                        <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                        <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                        <td>{hour.maxvisitors}</td>
                                        <td>${hour.price}</td>
                                        <td className="right">
                                          <button className="btn btn-link p-0 me-2" onClick={() => handleEditCategoryHours(
                                            categoryHours.findIndex(h => h.id === hour.id && h.plan === hour.plan)
                                          )}>
                                            <span className="material-symbols-outlined">edit</span>
                                          </button>
                                          <button className="btn btn-link p-0" onClick={() => {
                                            handleDeleteCategoryHours(
                                              categoryHours.findIndex(h => h.id === hour.id && h.plan === hour.plan)
                                            ); setActiveCategoryIndex(categoryIndex);
                                          }}>
                                            <span className="material-symbols-outlined">delete</span>
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          ))}
                          <div className="modal-footer">
                            <div className="following_days" id="following-days-section">

                              <p>Apply the above settings to the following days</p>
                              <div className="check_buttons" id="days-check-buttons">
                                {daysOfWeek
                                  .filter((day) => day !== selectedDay) // Exclude the currently selected day
                                  .map((day) => (
                                    <div
                                      key={day}
                                      className={`check_button ${selectedDays.includes(day) ? "active" : ""}`}
                                      onClick={() => handleDaySelect(day)}
                                      id={`day-select-${day}`}
                                    >
                                      {day.slice(0, 3).toUpperCase()}
                                    </div>
                                  ))}
                              </div>

                            </div>

                            {singleDayData?.storespotdayid ? <button disabled={loaderEnable} className="fill-btn-style" id="save-footer-button" onClick={handleCalender}>   {loaderEnable ? (
                              <img
                                src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                className="loading-icon"
                              />
                            ) : null}Update</button> : <button className="fill-btn-style" id="save-footer-button" disabled={loaderEnable} onClick={handleCalender}>   {loaderEnable ? (
                              <img
                                src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                className="loading-icon"
                              />
                            ) : null}Add</button>}

                          </div>
                        </div>


                      </Modal>


                      <Modal className="add_hours special-hours-popup" show={showSpecialHours} id="special-hours-modal">
                        <div className="modal-header">
                          <div className="add_hours_title">
                            <div className="modal-title h4" id="modal-title">ADD SPECIAL HOURS</div>
                          </div>
                          <button type="button" className="close-btn" id="close-button">
                            <span className="material-icons" onClick={handleClose}>close</span>
                          </button>
                        </div>

                        <div className="modal-body special-hours" id="modal-body">
                          <div className="special-hours-left" id="special-hours-left">
                            <h5 className="mt-3 fw-bold mx-3" id="selected-date-label">Selected Date</h5>
                            <div className="calendar-wrapper px-3" id="calendar-wrapper">
                              <Calendar
                                tileDisabled={disablePastDates}
                                //  className={workingHours?.length>0 ? 'disabled-calendar' : ''}
                                // className='disabled-calendar'
                                //  style={{
                                //       pointerEvents: workingHours?.length>0  ? 'none' : 'auto', // Disable all interactions
                                //       opacity: workingHours?.length>0  ? 0.5 : 1, // Dim the calendar to show it's disabled
                                //     }}


                                onChange={handleDateChange} id="calendar-component" />
                            </div>
                          </div>

                          <div className="special-hours-right" id="special-hours-right">
                            {selectedDate?.length > 0 ? (
                              <>
                                <div className="working_hours premium_hours" id="working-hours">
                                  <h6>SET STORE WORKING HOURS</h6>
                                </div>

                                <div className="table-responsive">
                                  <table className="table align-middle">
                                    <thead>
                                      <tr>
                                        <th width="30%">
                                          <div className="form-group">
                                            <label className="form_label" id="open-label">Opens</label>
                                            <select
                                              className="form-select"
                                              value={selectedStartTime}
                                              onChange={(e) => setSelectedStartTime(e.target.value)}
                                              id="spots-open-select"
                                            >
                                              <option value="">Select Open Time</option>
                                              {getStartTimeOptions().map(time => (
                                                <option key={time.value} value={time.value}>
                                                  {time.displayValue}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </th>
                                        <th width="30%">
                                          <div className="form-group">
                                            <label className="form_label" id="close-label">Closes</label>
                                            <select
                                              key={endTimeKey}
                                              className="form-select"
                                              value={selectedEndTime}
                                              onChange={(e) => setSelectedEndTime(e.target.value)}
                                              disabled={!selectedStartTime}
                                              id="spots-close-select"
                                            >
                                              <option value="">Select Close Time</option>
                                              {getEndTimeOptions().map(time => (
                                                <option key={time.value} value={time.value}>
                                                  {time.displayValue}
                                                </option>
                                              ))}
                                            </select>
                                          </div>
                                        </th>
                                        <th width="10%" className="right">
                                          <button
                                            className="fill-btn-style"
                                            id="save-button"
                                            onClick={handleAddWorkingHours}
                                          // disabled={!selectedStartTime || !selectedEndTime}
                                          >
                                            <span className="material-symbols-outlined">
                                              {editMode ? 'edit' : 'add_circle'}
                                            </span>
                                            {editMode ? 'update' : 'add'}
                                          </button>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>

                                      {workingHours.map((hour) => (
                                        <tr key={hour.id}>
                                          {/* <td>{hour.day}</td> */}
                                          <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                          <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                          <td className="right">
                                            <button className="btn btn-link p-0 me-2" onClick={() => handleEditWorkingHours(hour.id)} id="spots-edit-button">
                                              <span className="material-symbols-outlined">edit</span>
                                            </button>
                                            <button className="btn btn-link p-0" onClick={() => handleDeleteWorkingHours(hour.id)} id="spots-delete-button">
                                              <span className="material-symbols-outlined">delete</span>
                                            </button>
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>

                                {categoryTypes.map((category, categoryIndex) => (
                                  <div key={categoryIndex}>
                                    <div className="working_hours premium_hours">
                                      {/* <h6>{category.name}</h6> */}
                                      <h6 style={{ cursor: 'pointer' }} onClick={() => setActiveCategoryIndex(categoryIndex)}>{category.name}</h6>

                                    </div>
                                    <div className="table-responsive">
                                      <table className="table align-middle">
                                        <thead>
                                          <tr>
                                            <th width="25%">
                                              <div className="form-group">
                                                <label className="form_label" id="category-open-label">Opens</label>
                                                <select
                                                  className="form-select"
                                                  value={categoryIndex === activeCategoryIndex ? selectedCategoryStartTime : ''}
                                                  onChange={(e) => {
                                                    if (categoryIndex !== activeCategoryIndex) {
                                                      setActiveCategoryIndex(categoryIndex);
                                                    }
                                                    setSelectedCategoryStartTime(e.target.value);
                                                    setSelectedCategoryEndTime('');
                                                  }}
                                                  disabled={categoryIndex !== activeCategoryIndex}
                                                  id="spots-category-opens"
                                                >
                                                  <option value="">Select Open Time</option>
                                                  {categoryIndex === activeCategoryIndex && getCategoryStartTimeOptions().map(time => (
                                                    <option key={time.value} value={time.value}>
                                                      {time.displayValue}
                                                    </option>
                                                  ))}
                                                </select>
                                              </div>
                                            </th>
                                            <th width="25%">
                                              <div className="form-group">
                                                <label className="form_label" id="category-close-label">Closes</label>
                                                <select
                                                  key={categoryEndTimeKey}
                                                  className="form-select"
                                                  value={categoryIndex === activeCategoryIndex ? selectedCategoryEndTime : ''}
                                                  onChange={(e) => setSelectedCategoryEndTime(e.target.value)}
                                                  disabled={!selectedCategoryStartTime || categoryIndex !== activeCategoryIndex}
                                                  id="spots-category-close"
                                                >
                                                  <option value="">Select Close Time</option>
                                                  {categoryIndex === activeCategoryIndex && selectedCategoryStartTime && getCategoryEndTimeOptions().map(time => (
                                                    <option key={time.value} value={time.value}>
                                                      {time.displayValue}
                                                    </option>
                                                  ))}
                                                </select>
                                              </div>
                                            </th>
                                            <th width="20%">
                                              <div className="form-group">
                                                <label className="form_label" id="max-visitors-label">Max Visitors / Spot</label>
                                                <input
                                                  className="form-control"
                                                  placeholder="Enter"
                                                  type="text"
                                                  value={categoryIndex === activeCategoryIndex ? maxVisitors : ''}
                                                  onChange={(e) => setMaxVisitors(e.target.value)}
                                                  disabled={categoryIndex !== activeCategoryIndex}
                                                />
                                              </div>
                                            </th>
                                            <th width="20%">
                                              <div className="form-group">
                                                <label className="form_label" id="price-label">Price / Spot</label>
                                                <input
                                                  className="form-control"
                                                  placeholder="00.00"
                                                  type="text"
                                                  value={categoryIndex === activeCategoryIndex ? pricePerSpot : ''}
                                                  onChange={(e) => setPricePerSpot(e.target.value)}
                                                  disabled={categoryIndex !== activeCategoryIndex}
                                                />
                                              </div>
                                            </th>
                                            <th width="10%" className="right">
                                              <button
                                                className="fill-btn-style"
                                                id="save-button"
                                                onClick={handleAddCategoryHours}
                                                // disabled={!selectedCategoryStartTime || !selectedCategoryEndTime || categoryIndex !== activeCategoryIndex}
                                                disabled={categoryIndex !== activeCategoryIndex}                                              >
                                                <span className="material-symbols-outlined" >
                                                  {categoryEditMode && categoryIndex === activeCategoryIndex ? 'edit' : 'add_circle'}
                                                </span>
                                                {categoryEditMode && categoryIndex === activeCategoryIndex ? 'update' : 'add'}
                                              </button>
                                            </th>
                                          </tr>
                                        </thead>
                                        <tbody>

                                          {categoryHours
                                            .filter(hour => hour.plan === category.plan)
                                            .map((hour, idx) => {
                                              const rowId = `spots-${hour.id}`;
                                              const editBtnId = `spots-edit-${hour.id}`;
                                              const deleteBtnId = `spots-delete-${hour.id}`;
                                              return (
                                                <tr key={`${hour.id}-${idx}`} id={rowId}>
                                                  <td>{formatTimeForDisplay(hour.starttime, hour.day)}</td>
                                                  <td>{formatTimeForDisplay(hour.endtime, hour.endDay || hour.day, true, { day: hour.day, time: hour.starttime })}</td>
                                                  <td>{hour.maxvisitors}</td>
                                                  <td>${hour.price}</td>
                                                  <td className="right">
                                                    <button
                                                      className="btn btn-link p-0 me-2"
                                                      id={editBtnId}
                                                      onClick={() =>
                                                        handleEditCategoryHours(
                                                          categoryHours.findIndex(h => h.id === hour.id && h.plan === hour.plan)
                                                        )
                                                      }
                                                    >
                                                      <span className="material-symbols-outlined">edit</span>
                                                    </button>
                                                    <button
                                                      className="btn btn-link p-0"
                                                      id={deleteBtnId}
                                                      onClick={() => {
                                                        handleDeleteCategoryHours(
                                                          categoryHours.findIndex(h => h.id === hour.id && h.plan === hour.plan)
                                                        );
                                                        setActiveCategoryIndex(categoryIndex);
                                                      }}
                                                    >
                                                      <span className="material-symbols-outlined">delete</span>
                                                    </button>
                                                  </td>
                                                </tr>
                                              );
                                            })}

                                        </tbody>
                                      </table>
                                    </div>
                                  </div>
                                ))}

                                <div className="mx-2">
                                  {singleSplData?.storespotdayid ? <button className="fill-btn-style mt-3 mb-3" disabled={loaderEnable} onClick={handleCalender} id="update-calendar-button">
                                    {loaderEnable ? (
                                      <img
                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                        className="loading-icon"
                                      />
                                    ) : null}UPDATE</button> : <button className="fill-btn-style mt-3 mb-3" disabled={loaderEnable} onClick={handleCalender} id="add-calendar-button">
                                    {loaderEnable ? (
                                      <img
                                        src={"https://d3pha9ax8wzu0e.cloudfront.net/spotsaverDev/images/web/rotate_right.svg"}
                                        className="loading-icon"
                                      />
                                    ) : null}ADD</button>}

                                </div>
                              </>
                            ) : (
                              <div className="container text-center" id="no-spots-container">
                                <div className="image-container" style={{ marginTop: "60px" }}>
                                  <img
                                    src={`${image}${appname}/images/landingPage/spots-default-img.svg`}
                                    alt="No spots available"
                                    className="img-fluid"
                                    style={{ maxWidth: "300px" }}
                                    id="no-spots-image"
                                  />
                                </div>
                                <h5 className="mt-3 fw-bold" id="no-spots-message">Select Date And Continue</h5>
                                <p className="text-muted" id="no-spots-instruction">Click 'Add' To Set</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </Modal>

                      <ToastContainer
                        id="toastContainer-spots"
                        position="bottom-center"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover={false}
                        theme="light"
                      />
                    </div>
                  </div>
                </div>
              </div>


            </div>
          </div>
        }

      </div>
    </>
  );
};

export default SpotsManage;
